<template>
  <div>
    <div
      class="row-height row col-md-12"
      :class="showOverlay ? ' postion-relative' : ''"
    >
      <div
        v-if="showOverlay"
        class="wizard-absolute border-r-8 mt-4"
        @click="
          (dialog = false),
            (dialog1 = false),
            (showOverlay = false),
            (successDialog = false),
            (errorDialog = false)
        "
      ></div>
      <v-col class="col-xl-3 col-lg-5 col-md-12 pl-lg-0" cols="12">
        <v-card class="text-center" style="cursor: pointer">
          <v-row class="mx-2 justify-center mt-1 mb-2">
            <h5
              class="text-center text-underline mt-4 font-quicksand-medium-18"
            >
              New Patient Check Eligibility
            </h5>
          </v-row>
          <v-row class="mx-0 mt-3 text-left pl-5 pr-5">
            <div class="col-md-12 no-padding">
              <div class="col-md-12 padding-for-inputs">
                <label for="" class="text-left">First Name </label>
                <v-text-field
                  hide-details
                  v-model="firstName"
                  solo
                ></v-text-field>
              </div>
              <div class="col-md-12 padding-for-inputs">
                <label for="" class="text-left">Last Name </label>
                <v-text-field
                  hide-details
                  v-model="lastName"
                  solo
                ></v-text-field>
              </div>
              <div class="col-md-12 padding-for-inputs">
                <label for="" class="text-left">DOB</label>

                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dob"
                      solo
                      append-icon="mdi-calendar"
                      readonly
                      hide-details=""
                      persistent-hint
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="dob" no-title @input="menu = false">
                    <v-spacer></v-spacer>
                  </v-date-picker>
                </v-menu>
              </div>
              <div class="col-md-12 padding-for-inputs">
                <label for="" class="text-left">Payer ID</label>
                <v-text-field
                  hide-details
                  v-model="payerID"
                  solo
                ></v-text-field>
              </div>
              <div class="col-md-12 padding-for-inputs">
                <label for="" class="text-left">Group ID</label>
                <v-text-field
                  hide-details
                  v-model="groupID"
                  solo
                ></v-text-field>
              </div>
              <div class="col-md-12 padding-for-inputs">
                <label for="" class="text-left">Plan ID</label>
                <v-text-field hide-details solo v-model="planID"></v-text-field>
              </div>
              <div class="col-md-12 padding-for-inputs">
                <label for="" class="text-left">Member ID</label>
                <v-text-field
                  hide-details
                  solo
                  v-model="memberID"
                ></v-text-field>
              </div>
            </div>
            <br /><br />
            <div class="col-md-12 mt-8">
              <div
                class="col-md-12 check-eligibility"
                @click="checkEligibility()"
              >
                <svg
                  width="64"
                  height="64"
                  viewBox="0 0 54 54"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M23.7713 5.74543C24.1794 6.19751 24.6778 6.55892 25.2344 6.80627C25.7909 7.05363 26.3931 7.18144 27.0021 7.18144C27.6111 7.18144 28.2133 7.05363 28.7698 6.80627C29.3263 6.55892 29.8248 6.19751 30.2329 5.74543L32.3216 3.42968C32.9244 2.76457 33.718 2.30209 34.5938 2.10559C35.4696 1.90908 36.3847 1.98815 37.2138 2.33198C38.0429 2.6758 38.7455 3.26755 39.2253 4.02621C39.7052 4.78487 39.9388 5.67334 39.8942 6.56994L39.7342 9.68131C39.7033 10.2898 39.8003 10.898 40.0191 11.4667C40.2378 12.0353 40.5734 12.5518 41.0042 12.9826C41.435 13.4134 41.9513 13.7491 42.5198 13.9679C43.0884 14.1867 43.6965 14.2837 44.3049 14.2528L47.4157 14.0928C48.3145 14.0449 49.2061 14.2769 49.9676 14.7569C50.7291 15.2368 51.3231 15.941 51.6679 16.7725C52.0127 17.6041 52.0913 18.5221 51.8929 19.4002C51.6945 20.2783 51.2287 21.0732 50.5599 21.6756L48.2445 23.7647C47.7925 24.1729 47.4312 24.6714 47.1839 25.228C46.9366 25.7847 46.8088 26.387 46.8088 26.9961C46.8088 27.6052 46.9366 28.2075 47.1839 28.7641C47.4312 29.3208 47.7925 29.8193 48.2445 30.2275L50.5599 32.3165C51.2275 32.9189 51.6922 33.7132 51.8902 34.5904C52.0882 35.4676 52.0098 36.3846 51.6657 37.2155C51.3216 38.0463 50.7287 38.7501 49.9685 39.2303C49.2083 39.7105 48.3181 39.9435 47.4202 39.8972L44.3094 39.7372C43.701 39.7066 43.0931 39.8039 42.5247 40.0228C41.9563 40.2417 41.4401 40.5774 41.0094 41.0081C40.5787 41.4389 40.2431 41.9552 40.0243 42.5237C39.8054 43.0922 39.7081 43.7002 39.7387 44.3087L39.8987 47.42C39.9449 48.3181 39.712 49.2085 39.2319 49.9688C38.7518 50.7292 38.0481 51.3222 37.2174 51.6663C36.3867 52.0105 35.4699 52.0889 34.5929 51.8909C33.7158 51.6928 32.9216 51.228 32.3194 50.5603L30.2307 48.2445C29.8225 47.7925 29.3241 47.431 28.7676 47.1837C28.2111 46.9363 27.6089 46.8085 26.9999 46.8085C26.3909 46.8085 25.7886 46.9363 25.2321 47.1837C24.6756 47.431 24.1772 47.7925 23.7691 48.2445L21.6737 50.5625C21.0714 51.2302 20.2772 51.6951 19.4002 51.8931C18.5232 52.0912 17.6063 52.0127 16.7757 51.6685C15.945 51.3244 15.2413 50.7314 14.7612 49.971C14.2811 49.2107 14.0481 48.3203 14.0944 47.4222L14.2544 44.3109C14.2853 43.7024 14.1883 43.0941 13.9695 42.5255C13.7508 41.9568 13.4152 41.4404 12.9844 41.0096C12.5537 40.5787 12.0373 40.2431 11.4688 40.0243C10.9002 39.8055 10.2921 39.7084 9.68371 39.7394L6.57289 39.8994C5.67751 39.9419 4.79083 39.707 4.03398 39.2266C3.27713 38.7462 2.687 38.0439 2.34423 37.2155C2.00145 36.3871 1.92273 35.473 2.11883 34.5982C2.31492 33.7233 2.77627 32.9304 3.43985 32.3277L5.75519 30.2386C6.20719 29.8304 6.56853 29.3319 6.81585 28.7753C7.06316 28.2186 7.19095 27.6163 7.19095 27.0072C7.19095 26.3981 7.06316 25.7958 6.81585 25.2392C6.56853 24.6825 6.20719 24.184 5.75519 23.7758L3.43985 21.6868C2.77136 21.0846 2.30584 20.2901 2.10731 19.4124C1.90878 18.5348 1.98701 17.6172 2.33123 16.7859C2.67544 15.9546 3.26874 15.2503 4.0295 14.7701C4.79027 14.2898 5.68113 14.0571 6.57955 14.1039L9.69037 14.2639C10.2999 14.296 10.9094 14.1994 11.4792 13.9805C12.0489 13.7616 12.5663 13.4252 12.9976 12.9932C13.4289 12.5612 13.7644 12.0432 13.9825 11.473C14.2006 10.9028 14.2962 10.2931 14.2633 9.68353L14.1033 6.57216C14.0603 5.67644 14.2948 4.78927 14.7749 4.03191C15.255 3.27455 15.9573 2.68395 16.7856 2.34082C17.614 1.99769 18.5281 1.91878 19.403 2.11487C20.2779 2.31095 21.0709 2.77247 21.6737 3.43634L23.7713 5.74543Z"
                    stroke="#084BA7"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M33.668 27.5162L20.3359 19.7044V35.3301L33.668 27.5162Z"
                    stroke="#084BA7"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <h4 class="blue-text" style="color: #084ba7">
                  Check Eligibility & Register
                </h4>
              </div>
            </div>
          </v-row>
        </v-card>
      </v-col>
      <div class="col-lg-5">
        <div class="col-lg-12 pt-0">
          <h4 class="blue-text text-left mb-3">CONNECT WITH US</h4>

          <div style="display: flex; gap: 0.5rem">
            <v-card
              style="cursor: pointer; width: 50%; text-align: center"
              @click="callUser"
            >
              <br />
              <svg
                width="61"
                height="62"
                viewBox="0 0 46 46"
                fill="none"
                class="mt-1"
              >
                <path
                  d="M1.32764 25.5069C1.32764 30.8149 3.60879 35.9055 7.66928 39.6588C11.7298 43.4121 17.237 45.5207 22.9794 45.5207C28.7217 45.5207 34.2289 43.4121 38.2894 39.6588C42.3499 35.9055 44.6311 30.8149 44.6311 25.5069C44.6311 20.1989 42.3499 15.1083 38.2894 11.355C34.2289 7.60164 28.7217 5.49304 22.9794 5.49304C17.237 5.49304 11.7298 7.60164 7.66928 11.355C3.60879 15.1083 1.32764 20.1989 1.32764 25.5069Z"
                  fill="#E8F4FA"
                  stroke="#DAEDF7"
                  stroke-width="0.8"
                />
                <path d="M1 13.3397H13.0649V34.8106H1V13.3397Z" fill="white" />
                <path
                  d="M1 16.6661H13.0649V31.4834H1V16.6661Z"
                  fill="#00B8F0"
                />
                <path
                  d="M1 22.7434L7.91069 16.6661H1V22.7434Z"
                  fill="#4ACFFF"
                />
                <path
                  d="M1 13.3397H13.0649V34.8106H1V13.3397Z"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M1 16.6661H13.0649V31.4834H1V16.6661Z"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M6.43115 15.0028H9.44074"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M4.27979 15.0028H4.96956"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M33.276 0.906006H10.5049C9.7684 0.906006 9.0621 1.17643 8.54134 1.6578C8.02059 2.13916 7.72803 2.79203 7.72803 3.47278V18.3601C7.72803 18.6972 7.79985 19.0309 7.9394 19.3423C8.07895 19.6538 8.28349 19.9367 8.54134 20.1751C8.7992 20.4134 9.10531 20.6025 9.44221 20.7315C9.77911 20.8605 10.1402 20.9269 10.5049 20.9269H10.9081L10.5687 24.3792C10.5637 24.4307 10.5756 24.4825 10.6028 24.5276C10.6301 24.5727 10.6715 24.6092 10.7216 24.6323C10.7716 24.6553 10.8281 24.6638 10.8835 24.6567C10.9389 24.6496 10.9907 24.6272 11.0321 24.5924L15.3917 20.9289H33.276C34.0124 20.9289 34.7187 20.6584 35.2395 20.1771C35.7602 19.6957 36.0528 19.0428 36.0528 18.3621V3.47278C36.0528 2.79203 35.7602 2.13916 35.2395 1.6578C34.7187 1.17643 34.0124 0.906006 33.276 0.906006Z"
                  fill="white"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16.8618 16.6587H17.9866C18.1302 16.6587 18.2679 16.606 18.3694 16.5122C18.4709 16.4184 18.5279 16.2911 18.5279 16.1584V10.2273C18.5279 10.0946 18.4709 9.96731 18.3694 9.87348C18.2679 9.77964 18.1302 9.72693 17.9866 9.72693H16.8618V16.6587Z"
                  fill="white"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M24.9136 8.95697C25.1209 7.03914 25.3954 2.92529 23.6638 2.92529C23.3324 2.92529 23.0147 3.04696 22.7804 3.26353C22.5461 3.48009 22.4145 3.77382 22.4145 4.08009V4.46536C22.4145 7.28881 21.0894 10.2404 18.5264 10.2404V16.1444H18.8544C20.4555 16.1444 21.2139 17.1712 24.0827 17.1712H28.9419C29.0918 17.1773 29.2414 17.1553 29.3818 17.1065C29.5222 17.0577 29.6504 16.9831 29.7588 16.8873C29.8672 16.7914 29.9534 16.6763 30.0124 16.5488C30.0713 16.4213 30.1017 16.2841 30.1017 16.1454C30.1017 16.0068 30.0713 15.8696 30.0124 15.7421C29.9534 15.6146 29.8672 15.4994 29.7588 15.4036C29.6504 15.3077 29.5222 15.2332 29.3818 15.1844C29.2414 15.1356 29.0918 15.1136 28.9419 15.1197H29.4951C29.7809 15.1081 30.0509 14.9949 30.2486 14.8038C30.4464 14.6127 30.5568 14.3585 30.5568 14.094C30.5568 13.8296 30.4464 13.5753 30.2486 13.3842C30.0509 13.1932 29.7809 13.08 29.4951 13.0683H30.0505C30.2003 13.0744 30.35 13.0524 30.4904 13.0036C30.6308 12.9549 30.759 12.8803 30.8674 12.7844C30.9758 12.6886 31.062 12.5735 31.1209 12.446C31.1799 12.3185 31.2102 12.1812 31.2102 12.0426C31.2102 11.904 31.1799 11.7667 31.1209 11.6393C31.062 11.5118 30.9758 11.3966 30.8674 11.3008C30.759 11.2049 30.6308 11.1303 30.4904 11.0816C30.35 11.0328 30.2003 11.0108 30.0505 11.0169H30.6058C30.8898 11.0027 31.157 10.8884 31.3525 10.6976C31.5481 10.5068 31.6571 10.254 31.6571 9.99118C31.6571 9.72836 31.5481 9.47553 31.3525 9.28474C31.157 9.09394 30.8898 8.97968 30.6058 8.96547L24.9136 8.95697Z"
                  fill="#FFDA8F"
                />
                <path
                  d="M30.6058 8.95691H24.0806C24.0805 9.09176 24.1092 9.22529 24.165 9.34989C24.2208 9.47448 24.3026 9.58769 24.4057 9.68304C24.5089 9.77839 24.6314 9.85402 24.7662 9.90559C24.9009 9.95716 25.0454 9.98367 25.1913 9.98361H31.7166C31.7166 9.71131 31.5996 9.45017 31.3913 9.25762C31.183 9.06508 30.9004 8.95691 30.6058 8.95691Z"
                  fill="#FFE9BD"
                />
                <path
                  d="M24.7783 3.98453C24.6111 3.97977 24.4445 4.00611 24.2885 4.06198C24.1325 4.11784 23.9902 4.20211 23.8701 4.30976C23.75 4.41742 23.6546 4.54628 23.5894 4.6887C23.5241 4.83111 23.4906 4.98418 23.4906 5.13883V5.52409C23.4906 8.34755 22.1655 11.2996 19.6025 11.2996H18.5264V10.2404C21.0894 10.2404 22.4145 7.28831 22.4145 4.46536V4.08009C22.4145 3.77382 22.5461 3.48009 22.7804 3.26353C23.0147 3.04696 23.3324 2.92529 23.6638 2.92529C24.2186 2.92529 24.5672 3.34959 24.7783 3.98453Z"
                  fill="#FFE9BD"
                />
                <path
                  d="M23.8042 8.95691H24.9156"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M28.9399 15.1177H28.3853"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M29.4946 13.0641H28.9399"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M30.0512 11.011H29.4966"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M24.9136 8.95697C25.1209 7.03914 25.3954 2.92529 23.6638 2.92529C23.3324 2.92529 23.0147 3.04696 22.7804 3.26353C22.5461 3.48009 22.4145 3.77382 22.4145 4.08009V4.46536C22.4145 7.28881 21.0894 10.2404 18.5264 10.2404V16.1444H18.8544C20.4555 16.1444 21.2139 17.1712 24.0827 17.1712H28.9419C29.0918 17.1773 29.2414 17.1553 29.3818 17.1065C29.5222 17.0577 29.6504 16.9831 29.7588 16.8873C29.8672 16.7914 29.9534 16.6763 30.0124 16.5488C30.0713 16.4213 30.1017 16.2841 30.1017 16.1454C30.1017 16.0068 30.0713 15.8696 30.0124 15.7421C29.9534 15.6146 29.8672 15.4994 29.7588 15.4036C29.6504 15.3078 29.5222 15.2332 29.3818 15.1844C29.2414 15.1356 29.0918 15.1136 28.9419 15.1197H29.4951C29.7809 15.1081 30.0509 14.9949 30.2486 14.8038C30.4464 14.6127 30.5568 14.3585 30.5568 14.094C30.5568 13.8296 30.4464 13.5753 30.2486 13.3842C30.0509 13.1932 29.7809 13.08 29.4951 13.0683H30.0505C30.2003 13.0744 30.35 13.0524 30.4904 13.0036C30.6308 12.9549 30.759 12.8803 30.8674 12.7844C30.9758 12.6886 31.062 12.5735 31.1209 12.446C31.1799 12.3185 31.2102 12.1812 31.2102 12.0426C31.2102 11.904 31.1799 11.7667 31.1209 11.6393C31.062 11.5118 30.9758 11.3966 30.8674 11.3008C30.759 11.2049 30.6308 11.1303 30.4904 11.0816C30.35 11.0328 30.2003 11.0108 30.0505 11.0169H30.6058C30.8898 11.0027 31.157 10.8884 31.3525 10.6976C31.5481 10.5068 31.6571 10.254 31.6571 9.99118C31.6571 9.72836 31.5481 9.47553 31.3525 9.28474C31.157 9.09394 30.8898 8.97968 30.6058 8.96547L24.9136 8.95697Z"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.9741 9.21362H16.8617V17.1706H12.9741V9.21362Z"
                  fill="#009FD9"
                />
                <path
                  d="M12.9741 10.497V9.71397C12.9741 9.58127 13.0312 9.454 13.1327 9.36017C13.2342 9.26634 13.3719 9.21362 13.5154 9.21362H16.3215C16.465 9.21362 16.6027 9.26634 16.7042 9.36017C16.8057 9.454 16.8628 9.58127 16.8628 9.71397V10.497H12.9741Z"
                  fill="#00B8F0"
                />
                <path
                  d="M12.9741 9.21362H16.8617V17.1706H12.9741V9.21362Z"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M42.9751 28.8263H32.3257V26.6748C32.3257 26.4094 32.4397 26.1548 32.6428 25.9672C32.8458 25.7795 33.1212 25.6741 33.4083 25.6741H41.8925C42.1796 25.6741 42.455 25.7795 42.658 25.9672C42.861 26.1548 42.9751 26.4094 42.9751 26.6748V28.8263Z"
                  fill="white"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M41.8925 44.5782H33.4083C33.1212 44.5782 32.8458 44.4728 32.6428 44.2851C32.4397 44.0974 32.3257 43.8429 32.3257 43.5775V41.426H42.9751V43.5775C42.9751 43.8429 42.861 44.0974 42.658 44.2851C42.455 44.4728 42.1796 44.5782 41.8925 44.5782Z"
                  fill="white"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M32.3257 28.8259H42.9751V41.4256H32.3257V28.8259Z"
                  fill="#00B8F0"
                />
                <path
                  d="M32.3257 34.3382L38.2891 28.8259H32.3257V34.3382Z"
                  fill="#4ACFFF"
                />
                <path
                  d="M32.3257 28.8259H42.9751V41.4256H32.3257V28.8259Z"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M37.4351 27.2509H39.5651"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M35.7321 27.2509H35.3066"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16.3296 25.7373V36.6839C16.3296 37.1758 16.541 37.6476 16.9173 37.9955C17.2936 38.3433 17.804 38.5387 18.3362 38.5387H33.0474C33.5796 38.5387 34.09 38.3433 34.4663 37.9955C34.8426 37.6476 35.054 37.1758 35.054 36.6839V32.1508L37.7513 32.0932C37.7915 32.0967 37.8319 32.0887 37.8672 32.0705C37.9025 32.0523 37.931 32.0247 37.9489 31.9913C37.9669 31.9578 37.9735 31.9201 37.9679 31.8831C37.9623 31.8462 37.9447 31.8116 37.9174 31.784L35.054 29.1562V25.7373C35.054 25.2454 34.8426 24.7737 34.4663 24.4258C34.09 24.078 33.5796 23.8826 33.0474 23.8826H18.3362C17.804 23.8826 17.2936 24.078 16.9173 24.4258C16.541 24.7737 16.3296 25.2454 16.3296 25.7373Z"
                  fill="white"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M20.0205 31.2109C20.0205 32.647 20.6377 34.0242 21.7362 35.0397C22.8348 36.0551 24.3248 36.6256 25.8784 36.6256C27.432 36.6256 28.922 36.0551 30.0205 35.0397C31.1191 34.0242 31.7363 32.647 31.7363 31.2109C31.7363 29.7748 31.1191 28.3975 30.0205 27.3821C28.922 26.3666 27.432 25.7961 25.8784 25.7961C24.3248 25.7961 22.8348 26.3666 21.7362 27.3821C20.6377 28.3975 20.0205 29.7748 20.0205 31.2109Z"
                  fill="#FFE500"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M23.2173 29.9313C23.2173 30.0946 23.2875 30.2511 23.4124 30.3665C23.5373 30.4819 23.7068 30.5468 23.8835 30.5468C24.0602 30.5468 24.2296 30.4819 24.3545 30.3665C24.4795 30.2511 24.5497 30.0946 24.5497 29.9313C24.5497 29.7681 24.4795 29.6116 24.3545 29.4962C24.2296 29.3808 24.0602 29.3159 23.8835 29.3159C23.7068 29.3159 23.5373 29.3808 23.4124 29.4962C23.2875 29.6116 23.2173 29.7681 23.2173 29.9313Z"
                  fill="#C2C2C2"
                />
                <path
                  d="M27.209 29.9313C27.209 30.0946 27.2792 30.2511 27.4041 30.3665C27.529 30.4819 27.6985 30.5468 27.8752 30.5468C28.0519 30.5468 28.2213 30.4819 28.3462 30.3665C28.4712 30.2511 28.5414 30.0946 28.5414 29.9313C28.5414 29.7681 28.4712 29.6116 28.3462 29.4962C28.2213 29.3808 28.0519 29.3159 27.8752 29.3159C27.6985 29.3159 27.529 29.3808 27.4041 29.4962C27.2792 29.6116 27.209 29.7681 27.209 29.9313Z"
                  fill="#C2C2C2"
                />
                <path
                  d="M22.0981 31.4083C22.0981 31.5519 22.1599 31.6896 22.2698 31.7911C22.3797 31.8926 22.5288 31.9497 22.6842 31.9497C22.8396 31.9497 22.9887 31.8926 23.0986 31.7911C23.2085 31.6896 23.2702 31.5519 23.2702 31.4083C23.2702 31.2647 23.2085 31.127 23.0986 31.0255C22.9887 30.924 22.8396 30.8669 22.6842 30.8669C22.5288 30.8669 22.3797 30.924 22.2698 31.0255C22.1599 31.127 22.0981 31.2647 22.0981 31.4083Z"
                  fill="#FFAA54"
                />
                <path
                  d="M28.4893 31.4083C28.4893 31.5519 28.551 31.6896 28.6609 31.7911C28.7708 31.8926 28.9199 31.9497 29.0753 31.9497C29.2307 31.9497 29.3798 31.8926 29.4897 31.7911C29.5996 31.6896 29.6613 31.5519 29.6613 31.4083C29.6613 31.2647 29.5996 31.127 29.4897 31.0255C29.3798 30.924 29.2307 30.8669 29.0753 30.8669C28.9199 30.8669 28.7708 30.924 28.6609 31.0255C28.551 31.127 28.4893 31.2647 28.4893 31.4083Z"
                  fill="#FFAA54"
                />
                <path
                  d="M24.5483 32.8074C24.9427 33.0497 25.4059 33.1791 25.8797 33.1791C26.3534 33.1791 26.8166 33.0497 27.211 32.8074"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <div>
                <h5 class="blue-text">Call</h5>
              </div>
              <br />
            </v-card>
            <v-card
              style="cursor: pointer; width: 50%; text-align: center"
              @click="callUser"
              ><br />
              <svg
                width="61"
                height="62"
                viewBox="0 0 46 46"
                fill="none"
                class="mt-1"
              >
                <path
                  d="M1 25.6568C1 30.7869 3.26579 35.707 7.29893 39.3345C11.3321 42.9621 16.8022 45 22.5059 45C28.2096 45 33.6797 42.9621 37.7129 39.3345C41.746 35.707 44.0118 30.7869 44.0118 25.6568C44.0118 20.5267 41.746 15.6066 37.7129 11.9791C33.6797 8.35154 28.2096 6.3136 22.5059 6.3136C16.8022 6.3136 11.3321 8.35154 7.29893 11.9791C3.26579 15.6066 1 20.5267 1 25.6568Z"
                  fill="#E8F4FA"
                  stroke="#DAEDF7"
                  stroke-width="0.48"
                />
                <path
                  d="M28.048 37.3624C28.048 37.6458 27.986 37.9265 27.8655 38.1884C27.7449 38.4502 27.5682 38.6882 27.3453 38.8886C27.1225 39.089 26.8579 39.248 26.5668 39.3564C26.2756 39.4649 25.9636 39.5207 25.6484 39.5206H13.2051C12.89 39.5207 12.578 39.4649 12.2869 39.3564C11.9958 39.248 11.7312 39.089 11.5085 38.8886C11.2857 38.6882 11.109 38.4502 10.9885 38.1883C10.868 37.9265 10.806 37.6458 10.8062 37.3624V13.3579C10.8062 13.0746 10.8682 12.794 10.9888 12.5323C11.1093 12.2705 11.2861 12.0327 11.5088 11.8324C11.7316 11.632 11.9961 11.4731 12.2871 11.3648C12.5782 11.2564 12.8901 11.2006 13.2051 11.2007H25.649C26.2853 11.2008 26.8955 11.4283 27.3454 11.833C27.7952 12.2377 28.048 12.7866 28.048 13.3589V37.3624Z"
                  fill="white"
                />
                <path
                  d="M10.8062 37.3624C10.806 37.6458 10.868 37.9265 10.9885 38.1883C11.109 38.4502 11.2857 38.6882 11.5085 38.8886C11.7312 39.089 11.9958 39.248 12.2869 39.3564C12.578 39.4649 12.89 39.5207 13.2051 39.5206H25.6484C25.9636 39.5207 26.2756 39.4649 26.5668 39.3564C26.8579 39.248 27.1225 39.089 27.3453 38.8886C27.5682 38.6882 27.7449 38.4502 27.8655 38.1884C27.986 37.9265 28.048 37.6458 28.048 37.3624V35.4489C28.048 36.0212 27.7952 36.5702 27.3452 36.9749C26.8952 37.3797 26.2848 37.6071 25.6484 37.6071H13.2051C12.89 37.6071 12.578 37.5514 12.2869 37.4429C11.9958 37.3345 11.7312 37.1755 11.5085 36.9751C11.2857 36.7746 11.109 36.5367 10.9885 36.2748C10.868 36.0129 10.806 35.7323 10.8062 35.4489V37.3624Z"
                  fill="#DAEDF7"
                />
                <path
                  d="M28.048 37.3624C28.048 37.6458 27.986 37.9265 27.8655 38.1884C27.7449 38.4502 27.5682 38.6882 27.3453 38.8886C27.1225 39.089 26.8579 39.248 26.5668 39.3564C26.2756 39.4649 25.9636 39.5207 25.6484 39.5206H13.2051C12.89 39.5207 12.578 39.4649 12.2869 39.3564C11.9958 39.248 11.7312 39.089 11.5085 38.8886C11.2857 38.6882 11.109 38.4502 10.9885 38.1883C10.868 37.9265 10.806 37.6458 10.8062 37.3624V13.3579C10.8062 13.0746 10.8682 12.794 10.9888 12.5323C11.1093 12.2705 11.2861 12.0327 11.5088 11.8324C11.7316 11.632 11.9961 11.4731 12.2871 11.3648C12.5782 11.2564 12.8901 11.2006 13.2051 11.2007H25.649C26.2853 11.2008 26.8955 11.4283 27.3454 11.833C27.7952 12.2377 28.048 12.7866 28.048 13.3589V37.3624Z"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.3057 15.2452H26.549V35.1363H12.3057V15.2452Z"
                  fill="#00B8F0"
                />
                <path
                  d="M12.3057 25.9894L24.2511 15.2452H12.3057V25.9894Z"
                  fill="#4ACFFF"
                />
                <path
                  d="M12.3057 15.2452H26.549V35.1363H12.3057V15.2452Z"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M18.6772 13.2225H22.8005"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16.8941 13.2225C16.8941 13.3053 16.8668 13.3863 16.8156 13.4552C16.7645 13.524 16.6917 13.5777 16.6067 13.6094C16.5216 13.6411 16.428 13.6494 16.3377 13.6332C16.2473 13.6171 16.1644 13.5772 16.0993 13.5186C16.0341 13.46 15.9898 13.3854 15.9718 13.3042C15.9539 13.223 15.9631 13.1388 15.9983 13.0622C16.0336 12.9857 16.0933 12.9203 16.1698 12.8743C16.2464 12.8283 16.3364 12.8037 16.4285 12.8037C16.552 12.8037 16.6704 12.8478 16.7577 12.9264C16.845 13.0049 16.8941 13.1114 16.8941 13.2225Z"
                  fill="#45413C"
                />
                <path
                  d="M18.1152 37.328C18.1152 37.6409 18.2534 37.9411 18.4995 38.1623C18.7455 38.3836 19.0792 38.5079 19.4271 38.5079C19.775 38.5079 20.1087 38.3836 20.3547 38.1623C20.6007 37.9411 20.739 37.6409 20.739 37.328C20.739 37.0151 20.6007 36.7149 20.3547 36.4937C20.1087 36.2724 19.775 36.1481 19.4271 36.1481C19.0792 36.1481 18.7455 36.2724 18.4995 36.4937C18.2534 36.7149 18.1152 37.0151 18.1152 37.328Z"
                  fill="white"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  opacity="0.15"
                  d="M12.1235 43.2152C12.1235 43.4527 12.893 43.6805 14.2627 43.8485C15.6323 44.0164 17.49 44.1108 19.4269 44.1108C21.3639 44.1108 23.2216 44.0164 24.5912 43.8485C25.9609 43.6805 26.7303 43.4527 26.7303 43.2152C26.7303 42.9776 25.9609 42.7499 24.5912 42.5819C23.2216 42.4139 21.3639 42.3196 19.4269 42.3196C17.49 42.3196 15.6323 42.4139 14.2627 42.5819C12.893 42.7499 12.1235 42.9776 12.1235 43.2152Z"
                  fill="#45413C"
                />
                <path
                  d="M41.6808 1H23.0895C22.209 1 21.3645 1.31461 20.7419 1.87461C20.1193 2.43461 19.7695 3.19414 19.7695 3.98611V14.7356C19.7695 15.5276 20.1193 16.2871 20.7419 16.8471C21.3645 17.4071 22.209 17.7217 23.0895 17.7217H24.5718L23.7653 21.7122C23.742 21.8276 23.7569 21.9465 23.8082 22.0543C23.8595 22.1621 23.9449 22.2539 24.0538 22.3183C24.1628 22.3827 24.2903 22.4169 24.4207 22.4165C24.551 22.4161 24.6784 22.3812 24.7869 22.3162L32.4494 17.7222H41.6808C42.5612 17.7221 43.4056 17.4074 44.0281 16.8474C44.6506 16.2874 45.0003 15.528 45.0003 14.7361V3.98611C45.0003 3.19423 44.6506 2.43477 44.0281 1.87478C43.4056 1.31479 42.5612 1.00013 41.6808 1Z"
                  fill="white"
                />
                <path
                  d="M41.6808 1H23.0895C22.209 1 21.3645 1.31461 20.7419 1.87461C20.1193 2.43461 19.7695 3.19414 19.7695 3.98611V14.7356C19.7695 15.5276 20.1193 16.2871 20.7419 16.8471C21.3645 17.4071 22.209 17.7217 23.0895 17.7217H24.5718L23.7653 21.7122C23.742 21.8276 23.7569 21.9465 23.8082 22.0543C23.8595 22.1621 23.9449 22.2539 24.0538 22.3183C24.1628 22.3827 24.2903 22.4169 24.4207 22.4165C24.551 22.4161 24.6784 22.3812 24.7869 22.3162L32.4494 17.7222H41.6808C42.5612 17.7221 43.4056 17.4074 44.0281 16.8474C44.6506 16.2874 45.0003 15.528 45.0003 14.7361V3.98611C45.0003 3.19423 44.6506 2.43477 44.0281 1.87478C43.4056 1.31479 42.5612 1.00013 41.6808 1V1Z"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M25.0811 9.36058C25.0811 9.67737 25.221 9.98118 25.47 10.2052C25.7191 10.4292 26.0568 10.555 26.409 10.555C26.7612 10.555 27.099 10.4292 27.3481 10.2052C27.5971 9.98118 27.737 9.67737 27.737 9.36058C27.737 9.04379 27.5971 8.73998 27.3481 8.51598C27.099 8.29198 26.7612 8.16614 26.409 8.16614C26.0568 8.16614 25.7191 8.29198 25.47 8.51598C25.221 8.73998 25.0811 9.04379 25.0811 9.36058Z"
                  fill="#656769"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M31.0566 9.36058C31.0566 9.67737 31.1966 9.98118 31.4456 10.2052C31.6946 10.4292 32.0324 10.555 32.3846 10.555C32.7368 10.555 33.0746 10.4292 33.3237 10.2052C33.5727 9.98118 33.7126 9.67737 33.7126 9.36058C33.7126 9.04379 33.5727 8.73998 33.3237 8.51598C33.0746 8.29198 32.7368 8.16614 32.3846 8.16614C32.0324 8.16614 31.6946 8.29198 31.4456 8.51598C31.1966 8.73998 31.0566 9.04379 31.0566 9.36058Z"
                  fill="#656769"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M37.0322 9.36058C37.0322 9.67737 37.1721 9.98118 37.4212 10.2052C37.6702 10.4292 38.008 10.555 38.3602 10.555C38.7124 10.555 39.0502 10.4292 39.2992 10.2052C39.5483 9.98118 39.6882 9.67737 39.6882 9.36058C39.6882 9.04379 39.5483 8.73998 39.2992 8.51598C39.0502 8.29198 38.7124 8.16614 38.3602 8.16614C38.008 8.16614 37.6702 8.29198 37.4212 8.51598C37.1721 8.73998 37.0322 9.04379 37.0322 9.36058Z"
                  fill="#656769"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <div>
                <h5 class="blue-text">Text</h5>
              </div>
              <br />
            </v-card>
          </div>
        </div>

        <div class="col-lg-12">
          <h4 class="blue-text text-left mb-3">FIND CARE</h4>
          <div style="display: flex; gap: 0.5rem">
            <v-card
              style="cursor: pointer; width: 50%; text-align: center"
              @click="$router.push('/member/providers')"
              ><br />
              <svg
                width="61"
                height="62"
                viewBox="0 0 47 46"
                class="mt-1"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 25.5666C1 30.8484 3.29007 35.9138 7.36643 39.6486C11.4428 43.3834 16.9715 45.4816 22.7363 45.4816C28.5012 45.4816 34.0299 43.3834 38.1063 39.6486C42.1826 35.9138 44.4727 30.8484 44.4727 25.5666C44.4727 20.2848 42.1826 15.2194 38.1063 11.4846C34.0299 7.74979 28.5012 5.65161 22.7363 5.65161C16.9715 5.65161 11.4428 7.74979 7.36643 11.4846C3.29007 15.2194 1 20.2848 1 25.5666Z"
                  fill="#E8F4FA"
                  stroke="#DAEDF7"
                  stroke-width="0.8"
                />
                <path
                  opacity="0.15"
                  d="M13.4766 42.2079C13.4766 42.4852 14.4384 42.7511 16.1505 42.9472C17.8625 43.1432 20.1846 43.2534 22.6058 43.2534C25.027 43.2534 27.3491 43.1432 29.0612 42.9472C30.7732 42.7511 31.7351 42.4852 31.7351 42.2079C31.7351 41.9306 30.7732 41.6647 29.0612 41.4686C27.3491 41.2725 25.027 41.1624 22.6058 41.1624C20.1846 41.1624 17.8625 41.2725 16.1505 41.4686C14.4384 41.6647 13.4766 41.9306 13.4766 42.2079Z"
                  fill="#C2C2C2"
                />
                <path
                  d="M19.6289 36.6023H25.3689V39.7579H19.6289V36.6023Z"
                  fill="#C0DCEB"
                />
                <path
                  d="M19.6289 36.6023H25.3689V38.1801H19.6289V36.6023Z"
                  fill="#ADC4D9"
                />
                <path
                  d="M19.6289 36.6023H25.3689V39.7579H19.6289V36.6023Z"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M29.9599 41.8618H15.0352C15.0352 41.3039 15.277 40.7688 15.7076 40.3742C16.1381 39.9797 16.7221 39.7579 17.3311 39.7578H27.6635C28.2725 39.7578 28.8566 39.9795 29.2873 40.3741C29.718 40.7686 29.9599 41.3038 29.9599 41.8618Z"
                  fill="#E8F4FA"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M40.2926 15.0392C40.2925 14.3418 39.99 13.6731 39.4517 13.18C38.9135 12.6869 38.1835 12.4099 37.4223 12.4099H7.57287C6.81181 12.41 6.08196 12.6871 5.54381 13.1802C5.00566 13.6732 4.70327 14.3419 4.70312 15.0392V32.3951H40.2926V15.0392Z"
                  fill="#00B8F0"
                />
                <path
                  d="M26.814 12.4099H7.57731C7.20036 12.4098 6.82709 12.4778 6.47882 12.61C6.13055 12.7421 5.8141 12.9358 5.54756 13.18C5.28101 13.4242 5.06959 13.7141 4.92537 14.0332C4.78115 14.3523 4.70696 14.6943 4.70703 15.0397V32.6644L26.814 12.4099Z"
                  fill="#4ACFFF"
                />
                <path
                  d="M40.2926 15.0392C40.2925 14.3418 39.99 13.6731 39.4517 13.18C38.9135 12.6869 38.1835 12.4099 37.4223 12.4099H7.57287C6.81181 12.41 6.08196 12.6871 5.54381 13.1802C5.00566 13.6732 4.70327 14.3419 4.70312 15.0392V32.3951H40.2926V15.0392Z"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M23.8483 23.1531H10.3125L10.6271 11.3276H23.5336L23.8483 23.1531Z"
                  fill="#724F3D"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M26.8543 33.1124V28.6953C26.8543 26.2921 25.8123 23.9873 23.9576 22.288C22.1029 20.5887 19.5873 19.634 16.9643 19.634C14.3413 19.634 11.8257 20.5887 9.97095 22.288C8.1162 23.9873 7.07422 26.2921 7.07422 28.6953V33.1124H26.8543Z"
                  fill="#E8F4FA"
                />
                <path
                  d="M16.9643 19.635C14.3413 19.635 11.8257 20.5897 9.97094 22.289C8.1162 23.9883 7.07422 26.2931 7.07422 28.6963V31.2579C7.07422 28.8547 8.1162 26.5499 9.97094 24.8506C11.8257 23.1513 14.3413 22.1966 16.9643 22.1966C19.5873 22.1966 22.1028 23.1513 23.9576 24.8506C25.8123 26.5499 26.8543 28.8547 26.8543 31.2579V28.6953C26.854 26.2923 25.8119 23.9878 23.9572 22.2887C22.1025 20.5895 19.5871 19.635 16.9643 19.635Z"
                  fill="white"
                />
                <path
                  d="M26.8543 33.1124V28.6953C26.8543 26.2921 25.8123 23.9873 23.9576 22.288C22.1029 20.5887 19.5873 19.634 16.9643 19.634C14.3413 19.634 11.8257 20.5887 9.97095 22.288C8.1162 23.9873 7.07422 26.2921 7.07422 28.6953V33.1124H26.8543Z"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M19.2468 21.1511H14.6827L13.9219 22.5452L16.9644 33.1126L20.0075 22.5452L19.2468 21.1511Z"
                  fill="#A6FBFF"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M14.6817 19.522V21.151L13.9209 22.5451L16.964 33.1124H15.4424L12.4836 28.2577C12.4578 28.2155 12.444 28.1682 12.4434 28.1199C12.4429 28.0716 12.4555 28.024 12.4803 27.9814L13.4226 26.3468C13.4561 26.2888 13.4671 26.2221 13.4538 26.1576C13.4405 26.093 13.4036 26.0346 13.3492 25.9918L11.2049 24.308C11.1087 24.2323 11.0395 24.1318 11.0063 24.0196C10.9732 23.9074 10.9776 23.7886 11.0191 23.6787L11.6712 21.9516C11.9016 21.3431 12.3 20.7996 12.8275 20.3739C13.355 19.9482 13.9938 19.6547 14.6817 19.522Z"
                  fill="white"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M19.2472 19.522V21.151L20.008 22.5451L16.9648 33.1124H18.4864L21.4453 28.2577C21.4709 28.2155 21.4847 28.1682 21.4852 28.1199C21.4858 28.0716 21.4732 28.024 21.4485 27.9814L20.5057 26.3468C20.4723 26.2887 20.4614 26.222 20.4749 26.1575C20.4883 26.093 20.5252 26.0346 20.5796 25.9918L22.7234 24.308C22.8198 24.2324 22.8891 24.1319 22.9223 24.0196C22.9554 23.9074 22.9509 23.7886 22.9092 23.6787L22.2571 21.9516C22.0267 21.3432 21.6284 20.7997 21.101 20.374C20.5736 19.9483 19.935 19.6548 19.2472 19.522Z"
                  fill="white"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M19.2477 21.1515L16.9659 22.5456L14.6836 21.1515V18.0154H19.2477V21.1515Z"
                  fill="#D18660"
                />
                <path
                  d="M14.6836 19.8053C16.156 20.316 17.7833 20.3061 19.2482 19.7774V18.0154H14.6836V19.8053Z"
                  fill="#BD704A"
                />
                <path
                  d="M19.2477 21.1515L16.9659 22.5456L14.6836 21.1515V18.0154H19.2477V21.1515Z"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16.9645 22.5452L14.4952 24.5352L13.9219 22.5452L14.6827 21.1511L16.9645 22.5452Z"
                  fill="#A6FBFF"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16.9648 22.5452L19.4341 24.5352L20.0068 22.5452L19.2461 21.1511L16.9648 22.5452Z"
                  fill="#A6FBFF"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M23.0508 27.8408V33.1128"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M10.8789 27.8408V33.1128"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M23.2182 11.9045V10.4647C23.2182 8.93479 22.5548 7.46758 21.3741 6.3858C20.1934 5.30403 18.592 4.69629 16.9222 4.69629C15.2524 4.69629 13.651 5.30403 12.4703 6.3858C11.2896 7.46758 10.6263 8.93479 10.6263 10.4647V11.9085C10.2923 11.9085 9.97209 12.03 9.73596 12.2464C9.49984 12.4627 9.36719 12.7561 9.36719 13.0621C9.36719 13.368 9.49984 13.6614 9.73596 13.8778C9.97209 14.0941 10.2923 14.2156 10.6263 14.2156C10.6529 14.2156 10.6773 14.2102 10.7034 14.2087C10.926 15.5739 11.6763 16.8205 12.8177 17.7216C13.959 18.6227 15.4156 19.1184 16.9222 19.1184C18.4289 19.1184 19.8854 18.6227 21.0268 17.7216C22.1681 16.8205 22.9184 15.5739 23.141 14.2087C23.1671 14.2087 23.1915 14.2156 23.2182 14.2156C23.5521 14.2156 23.8724 14.0941 24.1085 13.8778C24.3446 13.6614 24.4773 13.368 24.4773 13.0621C24.4773 12.7561 24.3446 12.4627 24.1085 12.2464C23.8724 12.03 23.5521 11.9085 23.2182 11.9085V11.9045Z"
                  fill="#D18660"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M15.0234 15.8254C15.5342 16.2708 16.2124 16.5192 16.9175 16.5192C17.6226 16.5192 18.3008 16.2708 18.8115 15.8254"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M20.3859 12.4816C20.308 12.3104 20.1765 12.1642 20.008 12.0613C19.8395 11.9585 19.6415 11.9036 19.4391 11.9036C19.2366 11.9036 19.0386 11.9585 18.8701 12.0613C18.7016 12.1642 18.5701 12.3104 18.4922 12.4816"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M15.3547 12.4816C15.2768 12.3104 15.1453 12.1642 14.9768 12.0613C14.8083 11.9585 14.6103 11.9036 14.4078 11.9036C14.2053 11.9036 14.0074 11.9585 13.8389 12.0613C13.6704 12.1642 13.5389 12.3104 13.4609 12.4816"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.5156 14.3562C12.5156 14.5474 12.5985 14.7307 12.7461 14.8659C12.8937 15.0011 13.0938 15.0771 13.3025 15.0771C13.5112 15.0771 13.7113 15.0011 13.8589 14.8659C14.0064 14.7307 14.0893 14.5474 14.0893 14.3562C14.0893 14.165 14.0064 13.9816 13.8589 13.8464C13.7113 13.7112 13.5112 13.6353 13.3025 13.6353C13.0938 13.6353 12.8937 13.7112 12.7461 13.8464C12.5985 13.9816 12.5156 14.165 12.5156 14.3562Z"
                  fill="#BD704A"
                />
                <path
                  d="M19.7578 14.3562C19.7578 14.5474 19.8407 14.7307 19.9883 14.8659C20.1358 15.0011 20.336 15.0771 20.5447 15.0771C20.7533 15.0771 20.9535 15.0011 21.101 14.8659C21.2486 14.7307 21.3315 14.5474 21.3315 14.3562C21.3315 14.165 21.2486 13.9816 21.101 13.8464C20.9535 13.7112 20.7533 13.6353 20.5447 13.6353C20.336 13.6353 20.1358 13.7112 19.9883 13.8464C19.8407 13.9816 19.7578 14.165 19.7578 14.3562Z"
                  fill="#BD704A"
                />
                <path
                  d="M10.9122 11.9032H10.6289C10.9025 11.9215 11.1584 12.0339 11.3454 12.2177C11.5323 12.4016 11.6365 12.6433 11.637 12.8945C11.7463 12.5615 11.8131 12.218 11.836 11.8708C11.525 11.8924 11.217 11.9032 10.9122 11.9032Z"
                  fill="#724F3D"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M18.8125 7.2483V5.45595C18.8125 5.10075 18.9665 4.76009 19.2406 4.50893C19.5148 4.25776 19.8866 4.11666 20.2743 4.11666C20.7169 4.09974 21.1587 4.16408 21.5738 4.30591C21.9889 4.44774 22.3688 4.66418 22.6912 4.94252C23.0136 5.22086 23.272 5.55546 23.4512 5.92665C23.6304 6.29783 23.7268 6.6981 23.7347 7.10392C23.9174 8.7177 23.8442 10.3472 23.5173 11.9418C23.4202 11.9189 23.3204 11.9069 23.2201 11.9059C23.213 11.9059 23.2065 11.9059 23.2 11.9059C22.9312 11.9279 22.6811 12.041 22.4986 12.223C22.316 12.4051 22.2143 12.643 22.2132 12.8902C22.2132 12.8902 21.5241 12.1559 20.8003 11.3802C19.72 10.2306 18.8125 8.76433 18.8125 7.2483Z"
                  fill="#724F3D"
                />
                <path
                  d="M20.2743 5.56C20.7167 5.54308 21.1583 5.60734 21.5732 5.74902C21.9881 5.89069 22.3678 6.10691 22.6902 6.38498C23.0126 6.66305 23.2711 6.99735 23.4505 7.36825C23.6298 7.73914 23.7265 8.13913 23.7347 8.54473C23.7629 9.01173 23.7863 9.44388 23.801 9.85413C23.8363 9.0202 23.7972 8.14743 23.7347 7.1029C23.7268 6.69709 23.6304 6.29683 23.4512 5.92564C23.272 5.55446 23.0136 5.21987 22.6912 4.94153C22.3688 4.6632 21.9888 4.44676 21.5738 4.30493C21.1587 4.1631 20.7169 4.09876 20.2743 4.11569C19.8866 4.11569 19.5148 4.25679 19.2406 4.50795C18.9665 4.75911 18.8125 5.09976 18.8125 5.45495V6.89877C18.8126 6.54366 18.9667 6.20314 19.2408 5.95209C19.515 5.70104 19.8867 5.56 20.2743 5.56Z"
                  fill="#A86C4D"
                />
                <path
                  d="M18.8125 7.2483V5.45595C18.8125 5.10075 18.9665 4.76009 19.2406 4.50893C19.5148 4.25776 19.8866 4.11666 20.2743 4.11666V4.11666C20.7169 4.09974 21.1587 4.16408 21.5738 4.30591C21.9889 4.44774 22.3688 4.66418 22.6912 4.94252C23.0136 5.22086 23.272 5.55546 23.4512 5.92665C23.6304 6.29783 23.7268 6.6981 23.7347 7.10392C23.9174 8.7177 23.8442 10.3472 23.5173 11.9418C23.4202 11.9189 23.3204 11.9069 23.2201 11.9059C23.213 11.9059 23.2065 11.9059 23.2 11.9059C22.9312 11.9279 22.6811 12.041 22.4986 12.223C22.316 12.4051 22.2143 12.643 22.2132 12.8902C22.2132 12.8902 21.5241 12.1559 20.8003 11.3802C19.72 10.2306 18.8125 8.76433 18.8125 7.2483Z"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M20.0602 8.50058C17.8604 10.6703 14.1446 11.903 10.9124 11.903H9.99895C9.58147 11.9024 9.18134 11.75 8.88639 11.4793C8.59144 11.2086 8.42578 10.8417 8.42578 10.4592C8.42736 10.0777 8.59371 9.7122 8.88849 9.44269C9.18327 9.17317 9.5825 9.02151 9.99895 9.02086H10.3147C10.3147 5.99428 13.6219 3.54126 16.9252 3.54126C17.927 3.54126 18.8878 3.90587 19.5962 4.55488C20.3045 5.20389 20.7025 6.08414 20.7025 7.00198C20.7025 7.55788 20.473 8.09321 20.0602 8.50058Z"
                  fill="#724F3D"
                />
                <path
                  d="M16.925 3.54102C13.6216 3.54102 10.3145 5.99403 10.3145 9.0206C10.3145 9.0206 12.8326 5.27311 16.925 5.27311C17.7417 5.27328 18.5363 5.51596 19.1898 5.96476C19.8432 6.41356 20.3203 7.04431 20.5496 7.76248C20.6493 7.51852 20.701 7.26026 20.7023 6.99974C20.7017 6.08224 20.3035 5.20251 19.5952 4.55393C18.8869 3.90535 17.9264 3.54102 16.925 3.54102Z"
                  fill="#A86C4D"
                />
                <path
                  d="M20.0602 8.50058C17.8604 10.6703 14.1446 11.903 10.9124 11.903H9.99895C9.58147 11.9024 9.18134 11.75 8.88639 11.4793C8.59144 11.2086 8.42578 10.8417 8.42578 10.4592V10.4592C8.42736 10.0777 8.59371 9.7122 8.88849 9.44269C9.18327 9.17317 9.5825 9.02151 9.99895 9.02086H10.3147C10.3147 5.99428 13.6219 3.54126 16.9252 3.54126C17.927 3.54126 18.8878 3.90587 19.5962 4.55488C20.3045 5.20389 20.7025 6.08414 20.7025 7.00198V7.00198C20.7025 7.55788 20.473 8.09321 20.0602 8.50058Z"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M10.3125 9.021C10.7305 9.021 11.1313 9.17311 11.4268 9.44389C11.7224 9.71466 11.8884 10.0819 11.8884 10.4648"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M37.4223 36.6033C37.7992 36.6034 38.1724 36.5354 38.5207 36.4033C38.8689 36.2712 39.1853 36.0775 39.4519 35.8334C39.7184 35.5892 39.9298 35.2994 40.0741 34.9803C40.2184 34.6613 40.2926 34.3194 40.2926 33.974V32.3953H4.70313V33.973C4.70298 34.3184 4.77712 34.6605 4.92131 34.9796C5.0655 35.2988 5.27691 35.5888 5.54346 35.833C5.81001 36.0773 6.12648 36.2711 6.47479 36.4032C6.8231 36.5354 7.19641 36.6034 7.57341 36.6033H37.4223Z"
                  fill="white"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M21.875 34.4985C21.875 34.6497 21.9406 34.7947 22.0573 34.9016C22.1741 35.0085 22.3324 35.0686 22.4976 35.0686C22.6627 35.0686 22.821 35.0085 22.9378 34.9016C23.0545 34.7947 23.1201 34.6497 23.1201 34.4985C23.1201 34.3473 23.0545 34.2023 22.9378 34.0954C22.821 33.9885 22.6627 33.9285 22.4976 33.9285C22.3324 33.9285 22.1741 33.9885 22.0573 34.0954C21.9406 34.2023 21.875 34.3473 21.875 34.4985Z"
                  fill="#C2C2C2"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M46.0002 13.4521C46.0001 13.899 45.8062 14.3276 45.4613 14.6436C45.1164 14.9596 44.6486 15.1372 44.1608 15.1374H38.1833C38.0402 15.1374 37.9023 15.1866 37.7969 15.2753L33.8425 18.611C33.7609 18.6798 33.6593 18.7253 33.5499 18.742C33.4406 18.7587 33.3283 18.7459 33.2268 18.705C33.1253 18.6642 33.039 18.5972 32.9784 18.5122C32.9178 18.4271 32.8855 18.3277 32.8856 18.2262V15.6606C32.8856 15.522 32.8255 15.389 32.7185 15.291C32.6114 15.1929 32.4663 15.1379 32.315 15.1379H28.7654C28.5237 15.1381 28.2842 15.0946 28.0608 15.01C27.8374 14.9253 27.6344 14.8012 27.4633 14.6446C27.2923 14.4881 27.1566 14.3022 27.064 14.0975C26.9715 13.8929 26.9238 13.6736 26.9238 13.4521V2.62427C26.9238 2.1773 27.1176 1.74864 27.4626 1.43258C27.8075 1.11652 28.2754 0.938965 28.7633 0.938965H44.1608C44.6486 0.938965 45.1165 1.11652 45.4615 1.43258C45.8064 1.74864 46.0002 2.1773 46.0002 2.62427V13.4521Z"
                  fill="white"
                  stroke="#C2C2C2"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M31.6953 7.129C31.6952 7.03339 31.7157 6.93871 31.7556 6.85037C31.7955 6.76203 31.8541 6.68176 31.9278 6.61416C32.0016 6.54655 32.0892 6.49294 32.1857 6.45638C32.2821 6.41983 32.3854 6.40104 32.4898 6.40111H34.8743V4.21544C34.8742 4.11983 34.8947 4.02515 34.9346 3.93681C34.9745 3.84847 35.033 3.7682 35.1068 3.7006C35.1806 3.63299 35.2682 3.57938 35.3646 3.54282C35.461 3.50627 35.5644 3.48748 35.6687 3.48755H37.2582C37.3626 3.48748 37.4659 3.50626 37.5624 3.54281C37.6588 3.57936 37.7465 3.63297 37.8203 3.70057C37.8941 3.76817 37.9527 3.84843 37.9927 3.93677C38.0326 4.02512 38.0532 4.11981 38.0532 4.21544V6.40011H40.4371C40.5416 6.40005 40.6451 6.41886 40.7416 6.45547C40.8381 6.49208 40.9258 6.54578 40.9996 6.61348C41.0735 6.68119 41.132 6.76157 41.1719 6.85003C41.2118 6.93849 41.2323 7.03329 41.2321 7.129V8.58528C41.2321 8.77846 41.1484 8.96373 40.9993 9.10033C40.8502 9.23693 40.648 9.31367 40.4371 9.31367H38.0532V11.4978C38.0532 11.691 37.9694 11.8763 37.8203 12.0129C37.6713 12.1495 37.469 12.2262 37.2582 12.2262H35.6687C35.5643 12.2262 35.461 12.2074 35.3646 12.1708C35.2681 12.1342 35.1805 12.0805 35.1068 12.0129C35.033 11.9452 34.9745 11.8649 34.9346 11.7766C34.8947 11.6882 34.8742 11.5935 34.8743 11.4978V9.31268H32.4898C32.3854 9.31268 32.282 9.29383 32.1856 9.25722C32.0892 9.22061 32.0016 9.16695 31.9278 9.09931C31.854 9.03166 31.7955 8.95136 31.7556 8.86299C31.7157 8.77462 31.6952 8.67992 31.6953 8.58429V7.129Z"
                  fill="#FF6242"
                  stroke="#E04122"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <div>
                <h5 class="blue-text">Providers</h5>
              </div>
              <br />
            </v-card>
            <v-card
              style="cursor: pointer; width: 50%; text-align: center"
              @click="$router.push('/member/services')"
            >
              <br />
              <svg
                width="61"
                height="62"
                viewBox="0 0 46 40"
                class="mt-1"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M43.2293 19.5258C43.2297 16.612 42.5543 13.7351 41.2526 11.106C39.9508 8.47686 38.0559 6.1623 35.7066 4.33202C33.3573 2.50174 30.6134 1.20215 27.6759 0.528572C24.7385 -0.145008 21.682 -0.175498 18.7308 0.439336C15.7795 1.05417 13.0083 2.29874 10.6203 4.08176C8.23237 5.86479 6.28822 8.14105 4.93048 10.7436C3.57274 13.3462 2.83583 16.209 2.7738 19.1222C2.71177 22.0354 3.3262 24.9251 4.57201 27.5793H41.4268C42.6168 25.0499 43.2314 22.3038 43.2293 19.5258V19.5258Z"
                  fill="#C7F0FF"
                />
                <path
                  d="M4.57227 27.5793C6.17685 30.9979 8.76836 33.8977 12.0365 35.9315C15.3047 37.9653 19.111 39.047 22.9997 39.047C26.8884 39.047 30.6947 37.9653 33.9628 35.9315C37.231 33.8977 39.8225 30.9979 41.4271 27.5793H4.57227Z"
                  fill="#DAEDF7"
                />
                <path
                  d="M3.27539 27.5793H42.7237"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M1 27.5793H2.26437"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M43.7363 27.5793H45.0007"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M22.6055 5.69336H41.839V19.2579H22.6055V5.69336Z"
                  fill="white"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M22.6054 20.6847C22.3625 20.6848 22.122 20.6387 21.8976 20.549C21.6732 20.4594 21.4694 20.3279 21.2976 20.1622C21.1259 19.9965 20.9896 19.7998 20.8967 19.5833C20.8037 19.3667 20.7559 19.1346 20.7559 18.9003V6.05032C20.7559 5.81595 20.8037 5.58386 20.8967 5.36733C20.9896 5.1508 21.1259 4.95406 21.2976 4.78835C21.4694 4.62264 21.6732 4.49121 21.8976 4.40156C22.122 4.31191 22.3625 4.26581 22.6054 4.26587V20.6847Z"
                  fill="#8CA4B8"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M43.6869 18.9012C43.6866 19.3743 43.4917 19.828 43.145 20.1624C42.7983 20.4968 42.3281 20.6847 41.8379 20.6847V4.26587C42.3283 4.26587 42.7986 4.45387 43.1453 4.78852C43.4921 5.12317 43.6869 5.57706 43.6869 6.05032V18.9012Z"
                  fill="#8CA4B8"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M22.6055 4.26587H41.839V5.69353H22.6055V4.26587Z"
                  fill="#F0F0F0"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M22.6055 19.2581H41.839V20.6857H22.6055V19.2581Z"
                  fill="#F0F0F0"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M25.9336 5.69336H38.5095V19.2579H25.9336V5.69336Z"
                  fill="#525252"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M31.1133 11.5755V13.3541C31.1037 13.6595 30.9897 13.9533 30.789 14.1895C30.5882 14.4258 30.3121 14.5913 30.0037 14.6603C29.3119 14.8472 28.62 14.8755 27.9302 15.4798C27.886 15.5183 27.8313 15.5437 27.7725 15.5528C27.7137 15.5619 27.6535 15.5543 27.5991 15.531C27.5447 15.5077 27.4984 15.4696 27.466 15.4215C27.4336 15.3733 27.4163 15.3171 27.4163 15.2596V12.4722C27.4076 11.9725 27.5873 11.4868 27.9221 11.1055C28.2134 10.7787 28.564 10.506 28.9568 10.3006C29.1828 10.1885 29.4349 10.1344 29.6888 10.1436C29.9427 10.1527 30.1899 10.2248 30.4065 10.3529C30.6232 10.481 30.802 10.6608 30.9258 10.8749C31.0496 11.089 31.1142 11.3303 31.1133 11.5755V11.5755Z"
                  stroke="#E8F4FA"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M35.4891 10.3012C35.2632 10.1889 35.0111 10.1346 34.7572 10.1435C34.5032 10.1525 34.2559 10.2245 34.0392 10.3525C33.8224 10.4805 33.6435 10.6603 33.5196 10.8744C33.3958 11.0885 33.3312 11.3299 33.332 11.5751V13.3537C33.3415 13.6591 33.4556 13.9529 33.6563 14.1892C33.857 14.4255 34.1332 14.591 34.4416 14.6598C35.1335 14.8468 35.8254 14.8751 36.5152 15.4794C36.5593 15.518 36.614 15.5434 36.6728 15.5525C36.7316 15.5616 36.7918 15.5541 36.8462 15.5307C36.9006 15.5074 36.9468 15.4693 36.9792 15.4211C37.0115 15.3729 37.0287 15.3167 37.0285 15.2592V12.4717C37.0373 11.9721 36.8575 11.4864 36.5228 11.1051C36.2318 10.7786 35.8815 10.5062 35.4891 10.3012V10.3012Z"
                  stroke="#E8F4FA"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M31.1133 11.7617H33.3325"
                  stroke="#E8F4FA"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M32.2227 8.19189V11.7618"
                  stroke="#E8F4FA"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M33.332 13.2466C34.6132 13.0695 35.9186 13.3215 37.0306 13.9607Z"
                  fill="#656769"
                />
                <path
                  d="M33.332 13.2466C34.6132 13.0695 35.9186 13.3215 37.0306 13.9607"
                  stroke="#E8F4FA"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M33.332 11.7618C34.6131 11.5846 35.9185 11.8365 37.0306 12.4754Z"
                  fill="#656769"
                />
                <path
                  d="M33.332 11.7618C34.6131 11.5846 35.9185 11.8365 37.0306 12.4754"
                  stroke="#E8F4FA"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M31.1111 13.2466C29.8298 13.0695 28.5243 13.3215 27.4121 13.9607Z"
                  fill="#656769"
                />
                <path
                  d="M31.1111 13.2466C29.8298 13.0695 28.5243 13.3215 27.4121 13.9607"
                  stroke="#E8F4FA"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M31.1111 11.7619C29.8299 11.585 28.5244 11.8368 27.4121 12.4755Z"
                  fill="#656769"
                />
                <path
                  d="M31.1111 11.7619C29.8299 11.585 28.5244 11.8368 27.4121 12.4755"
                  stroke="#E8F4FA"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  opacity="0.15"
                  d="M6.09961 38.9962C6.09961 39.2623 6.83013 39.5176 8.13047 39.7058C9.43081 39.894 11.1944 39.9997 13.0334 39.9997C14.8724 39.9997 16.636 39.894 17.9363 39.7058C19.2367 39.5176 19.9672 39.2623 19.9672 38.9962C19.9672 38.73 19.2367 38.4748 17.9363 38.2866C16.636 38.0984 14.8724 37.9927 13.0334 37.9927C11.1944 37.9927 9.43081 38.0984 8.13047 38.2866C6.83013 38.4748 6.09961 38.73 6.09961 38.9962V38.9962Z"
                  fill="#45413C"
                />
                <path
                  d="M21.4178 25.7784C21.4174 26.0985 21.2854 26.4054 21.0508 26.6318C20.8163 26.8582 20.4983 26.9855 20.1665 26.9859C17.4092 26.9859 14.3262 24.4039 14.3262 20.9468V20.5382C14.3328 20.2221 14.4675 19.9211 14.7015 19.6998C14.9355 19.4785 15.25 19.3545 15.5776 19.3545C15.9053 19.3545 16.2198 19.4785 16.4538 19.6998C16.6878 19.9211 16.8225 20.2221 16.8291 20.5382V20.9448C16.8291 23.1568 18.8061 24.5684 20.167 24.5684C20.4991 24.5689 20.8174 24.6966 21.0519 24.9235C21.2864 25.1504 21.418 25.4579 21.4178 25.7784Z"
                  fill="#FFCEBF"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.8245 36.6485H9.32103L8.9043 31.8174H11.8245V36.6485Z"
                  fill="#FFCEBF"
                />
                <path
                  d="M11.8245 36.6485H9.32103L8.9043 31.8174H11.8245V36.6485Z"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.8242 36.6485H14.3272L14.7444 31.8174H11.8242V36.6485Z"
                  fill="#FFCEBF"
                />
                <path
                  d="M11.8242 36.6485H14.3272L14.7444 31.8174H11.8242V36.6485Z"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path d="M11.8242 31.8174V38.2592Z" fill="#FFCEBF" />
                <path
                  d="M11.8242 31.8174V38.2592"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.8223 36.6484H13.908C15.9522 36.6484 16.4215 38.6618 16.4215 38.6618H11.8223V36.6484Z"
                  fill="#87898C"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linejoin="round"
                />
                <path
                  d="M9.32031 36.6484H11.4065C13.4507 36.6484 13.9201 38.6618 13.9201 38.6618H10.0137C9.8298 38.6618 9.65343 38.5913 9.5234 38.4658C9.39336 38.3403 9.32031 38.1701 9.32031 37.9926V36.6484Z"
                  fill="#87898C"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linejoin="round"
                />
                <path
                  d="M20.291 25.5036L25.3278 16.759"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M17.2476 18.9338C17.2476 18.1847 17.0929 17.4432 16.7925 16.7524C16.4921 16.0617 16.0521 15.4357 15.4982 14.911C14.9443 14.3862 14.2875 13.9733 13.5663 13.6963C12.8452 13.4194 12.074 13.2839 11.298 13.2979C9.7448 13.3572 8.27692 13.9991 7.2066 15.0869C6.13628 16.1748 5.54798 17.6227 5.56685 19.1227V26.4016H8.07232V24.973V26.609L7.35315 32.5637C7.3425 32.7017 7.36146 32.8402 7.40884 32.9708C7.45622 33.1013 7.53099 33.221 7.62849 33.3224C7.72599 33.4238 7.84412 33.5047 7.97549 33.56C8.10685 33.6153 8.24863 33.6438 8.39195 33.6439H15.4218C15.5674 33.6438 15.7113 33.6143 15.8443 33.5573C15.9773 33.5003 16.0964 33.4171 16.1941 33.3129C16.2917 33.2088 16.3656 33.086 16.4111 32.9526C16.4566 32.8192 16.4726 32.6781 16.4581 32.5383L15.5791 26.609V24.5527C16.4366 25.6982 17.6888 26.5115 19.1113 26.8467L19.4587 24.4551C19.4587 24.4551 17.2476 23.824 17.2476 21.0795V18.9338Z"
                  fill="#F0F0F0"
                />
                <path
                  d="M11.298 15.3112C12.074 15.2971 12.8452 15.4325 13.5664 15.7094C14.2876 15.9863 14.9444 16.3992 15.4983 16.9239C16.0523 17.4486 16.4923 18.0746 16.7926 18.7653C17.093 19.456 17.2477 20.1976 17.2476 20.9467V18.9338C17.2476 18.1847 17.0929 17.4432 16.7925 16.7524C16.4921 16.0617 16.0521 15.4357 15.4982 14.911C14.9443 14.3862 14.2875 13.9733 13.5664 13.6963C12.8452 13.4194 12.074 13.2839 11.298 13.2979C9.7448 13.3572 8.27692 13.9991 7.2066 15.0869C6.13628 16.1748 5.54798 17.6227 5.56685 19.1227V21.1336C5.54864 19.6341 6.13724 18.1867 7.20749 17.0994C8.27774 16.0121 9.74524 15.3706 11.298 15.3112V15.3112Z"
                  fill="white"
                />
                <path
                  d="M17.2476 18.9338C17.2476 18.1847 17.0929 17.4432 16.7925 16.7524C16.4921 16.0617 16.0521 15.4357 15.4982 14.911C14.9443 14.3862 14.2875 13.9733 13.5663 13.6963C12.8452 13.4194 12.074 13.2839 11.298 13.2979C9.7448 13.3572 8.27692 13.9991 7.2066 15.0869C6.13628 16.1748 5.54798 17.6227 5.56685 19.1227V26.4016H8.07232V24.973V26.609L7.35315 32.5637C7.3425 32.7017 7.36146 32.8402 7.40884 32.9708C7.45622 33.1013 7.53099 33.221 7.62849 33.3224C7.72599 33.4238 7.84412 33.5047 7.97549 33.56C8.10685 33.6153 8.24863 33.6438 8.39195 33.6439H15.4218C15.5674 33.6438 15.7113 33.6143 15.8443 33.5573C15.9773 33.5003 16.0964 33.4171 16.1941 33.3129C16.2917 33.2088 16.3656 33.086 16.4111 32.9526C16.4566 32.8192 16.4726 32.6781 16.4581 32.5383L15.5791 26.609V24.5527C16.4366 25.6982 17.6888 26.5115 19.1113 26.8467L19.4587 24.4551C19.4587 24.4551 17.2476 23.824 17.2476 21.0795V18.9338Z"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M10.2218 14.4995L11.823 20.0388L13.4414 14.4258C12.4168 14.8485 11.2631 14.8751 10.2188 14.5L10.2218 14.4995Z"
                  fill="#FF87AF"
                  stroke="#45413C"
                  stroke-width="0.48432"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M13.3066 13.602C13.2034 13.5684 13.1137 13.5044 13.0502 13.419C12.9867 13.3336 12.9525 13.2312 12.9525 13.1261V11.5706H10.5502V12.9396C10.5503 13.054 10.5098 13.165 10.4356 13.2542C10.3614 13.3434 10.2578 13.4055 10.1421 13.4302C10.0708 13.4453 9.99999 13.4619 9.92969 13.479L10.224 14.4991C11.2683 14.8742 12.4221 14.8476 13.4467 14.4249L13.649 13.7269C13.5433 13.685 13.4163 13.6386 13.3066 13.602Z"
                  fill="#FFCEBF"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.06836 24.9729V19.3364"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.8242 20.0388V33.6463"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9.92706 13.48L8.4341 15.0116C8.37889 15.0684 8.3381 15.1368 8.31493 15.2114C8.29176 15.286 8.28684 15.3647 8.30057 15.4415C8.31429 15.5182 8.34629 15.5908 8.39403 15.6536C8.44178 15.7164 8.50397 15.7676 8.57571 15.8033L9.06123 16.0434C9.12509 16.0754 9.18141 16.1197 9.22664 16.1737C9.27187 16.2276 9.30503 16.29 9.32404 16.357C9.34304 16.4239 9.34748 16.4939 9.33706 16.5626C9.32665 16.6313 9.30161 16.6972 9.26352 16.756L9.0764 17.0489C9.01267 17.1482 8.98675 17.2659 9.00308 17.3817C9.01941 17.4974 9.07698 17.6041 9.16591 17.6834L11.8211 20.0399L9.92706 13.48Z"
                  fill="white"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M13.648 13.7273L15.2108 15.0115C15.2661 15.0682 15.3069 15.1367 15.3301 15.2113C15.3533 15.2859 15.3582 15.3647 15.3444 15.4415C15.3306 15.5183 15.2985 15.5909 15.2507 15.6537C15.2028 15.7164 15.1405 15.7676 15.0687 15.8031L14.5831 16.0433C14.5191 16.075 14.4625 16.1192 14.417 16.173C14.3715 16.2269 14.3381 16.2893 14.3189 16.3563C14.2996 16.4232 14.295 16.4933 14.3052 16.5621C14.3154 16.6309 14.3403 16.6969 14.3783 16.7559L14.5659 17.0487C14.6297 17.1481 14.6556 17.2657 14.6393 17.3815C14.6229 17.4973 14.5654 17.604 14.4764 17.6833L11.8223 20.0388L13.648 13.7273Z"
                  fill="white"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M15.5781 21.7521C15.5779 21.2522 15.7385 20.7646 16.0378 20.3567C16.2913 19.9612 16.4212 19.5037 16.4121 19.0388"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M5.56666 26.4014V27.791C5.56331 27.9516 5.59321 28.1113 5.6546 28.2607C5.71599 28.41 5.80764 28.5461 5.92418 28.6608C6.04072 28.7756 6.17981 28.8667 6.33331 28.929C6.48681 28.9912 6.65163 29.0233 6.81813 29.0233C6.98463 29.0233 7.14945 28.9912 7.30295 28.929C7.45645 28.8667 7.59554 28.7756 7.71208 28.6608C7.82862 28.5461 7.92027 28.41 7.98166 28.2607C8.04305 28.1113 8.07295 27.9516 8.0696 27.791V26.4014H5.56666Z"
                  fill="#FFCEBF"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.97656 25.6772H10.8215"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.7539 25.6772H14.5989"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.7377 3.15747C11.1964 3.15747 10.6603 3.26039 10.1601 3.46036C9.6599 3.66032 9.20543 3.95341 8.82263 4.32289C8.43983 4.69238 8.13619 5.13101 7.92905 5.61375C7.72191 6.09649 7.61534 6.61388 7.6154 7.13638V7.93196C6.43802 7.93196 6.51844 9.92142 7.82124 9.92142H7.82478C8.11793 10.8281 8.73839 11.6033 9.57344 12.106C10.4085 12.6087 11.4027 12.8057 12.3754 12.6611C13.3482 12.5164 14.2348 12.0398 14.8744 11.3178C15.5139 10.5958 15.8638 9.67641 15.8606 8.72657V7.1354C15.8605 6.61295 15.7538 6.09562 15.5466 5.61296C15.3394 5.1303 15.0357 4.69176 14.6528 4.32238C14.27 3.95299 13.8155 3.66 13.3153 3.46012C12.8152 3.26025 12.2791 3.15741 11.7377 3.15747V3.15747Z"
                  fill="#FFCEBF"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M10.502 8.03154C10.502 8.16345 10.5562 8.28996 10.6529 8.38323C10.7495 8.47651 10.8806 8.52891 11.0173 8.52891C11.154 8.52891 11.2851 8.47651 11.3817 8.38323C11.4784 8.28996 11.5327 8.16345 11.5327 8.03154C11.5327 7.89963 11.4784 7.77313 11.3817 7.67985C11.2851 7.58658 11.154 7.53418 11.0173 7.53418C10.8806 7.53418 10.7495 7.58658 10.6529 7.67985C10.5562 7.77313 10.502 7.89963 10.502 8.03154Z"
                  fill="#45413C"
                />
                <path
                  d="M13.5918 8.03154C13.5918 8.09686 13.6051 8.16153 13.631 8.22188C13.6569 8.28222 13.6949 8.33705 13.7427 8.38323C13.7906 8.42942 13.8474 8.46605 13.9099 8.49105C13.9725 8.51604 14.0395 8.52891 14.1072 8.52891C14.1748 8.52891 14.2418 8.51604 14.3044 8.49105C14.3669 8.46605 14.4237 8.42942 14.4716 8.38323C14.5194 8.33705 14.5574 8.28222 14.5833 8.22188C14.6092 8.16153 14.6225 8.09686 14.6225 8.03154C14.6225 7.96623 14.6092 7.90155 14.5833 7.84121C14.5574 7.78087 14.5194 7.72604 14.4716 7.67985C14.4237 7.63367 14.3669 7.59703 14.3044 7.57204C14.2418 7.54704 14.1748 7.53418 14.1072 7.53418C14.0395 7.53418 13.9725 7.54704 13.9099 7.57204C13.8474 7.59703 13.7906 7.63367 13.7427 7.67985C13.6949 7.72604 13.6569 7.78087 13.631 7.84121C13.6051 7.90155 13.5918 7.96623 13.5918 8.03154V8.03154Z"
                  fill="#45413C"
                />
                <path
                  d="M10.5001 9.6224C10.5001 9.70108 10.476 9.77799 10.4307 9.8434C10.3854 9.90882 10.321 9.95981 10.2457 9.98992C10.1704 10.02 10.0875 10.0279 10.0076 10.0126C9.9276 9.9972 9.85415 9.95932 9.79651 9.90368C9.73886 9.84805 9.69961 9.77717 9.6837 9.70001C9.6678 9.62284 9.67596 9.54286 9.70716 9.47017C9.73835 9.39749 9.79118 9.33536 9.85897 9.29165C9.92675 9.24794 10.0064 9.22461 10.088 9.22461C10.1973 9.22461 10.3021 9.26652 10.3794 9.34112C10.4567 9.41572 10.5001 9.5169 10.5001 9.6224V9.6224Z"
                  fill="#FFB59E"
                />
                <path
                  d="M11.5332 10.2815C11.8188 10.5219 12.1849 10.6544 12.5639 10.6544C12.9429 10.6544 13.3091 10.5219 13.5946 10.2815"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.84666 8.32944C8.84666 7.90731 9.02041 7.50247 9.32971 7.20397C9.639 6.90548 10.0585 6.73778 10.4959 6.73778H16.2827C16.3318 6.73784 16.3803 6.72771 16.425 6.70807C16.4697 6.68843 16.5095 6.65974 16.5416 6.62396C16.5738 6.58817 16.5977 6.54612 16.6115 6.50066C16.6254 6.45521 16.629 6.4074 16.622 6.36049C16.479 5.26738 15.9688 4.24961 15.1695 3.46289C14.3702 2.67617 13.3258 2.16384 12.1962 2.00429C11.4691 1.91265 10.73 1.97177 10.0284 2.17771C9.32684 2.38364 8.67884 2.73166 8.1277 3.19851C7.57656 3.66537 7.13496 4.24032 6.83238 4.88499C6.5298 5.52966 6.3732 6.2292 6.37305 6.93693V12.7701C6.37405 12.8711 6.39873 12.9706 6.44523 13.0611C6.49173 13.1516 6.55884 13.2308 6.64154 13.2927C6.72425 13.3547 6.8204 13.3977 6.92279 13.4187C7.02519 13.4397 7.13118 13.438 7.23282 13.4139C8.26404 13.1762 8.72022 12.4763 8.84615 11.5128L8.84666 8.32944Z"
                  fill="#FFC44D"
                />
                <path
                  d="M11.3202 3.55502C12.3083 3.55792 13.2843 3.76563 14.1821 4.1641C15.0798 4.56257 15.8784 5.14251 16.5238 5.86466C16.2863 4.80434 15.6945 3.84866 14.8394 3.14454C13.9843 2.44042 12.9133 2.02685 11.7909 1.9674C10.6685 1.90796 9.55701 2.20594 8.62721 2.81552C7.69742 3.42511 7.00082 4.31256 6.64453 5.34143C7.91286 4.19667 9.5836 3.55833 11.3202 3.55502V3.55502Z"
                  fill="#FFDB94"
                />
                <path
                  d="M8.84666 8.32944C8.84666 7.90731 9.02041 7.50247 9.32971 7.20397C9.639 6.90548 10.0585 6.73778 10.4959 6.73778H16.2827C16.3318 6.73784 16.3803 6.72771 16.425 6.70807C16.4697 6.68843 16.5095 6.65974 16.5416 6.62396C16.5738 6.58817 16.5977 6.54612 16.6115 6.50066C16.6254 6.45521 16.629 6.4074 16.622 6.36049C16.479 5.26738 15.9688 4.24961 15.1695 3.46289C14.3702 2.67617 13.3258 2.16384 12.1962 2.00429C11.4691 1.91265 10.73 1.97177 10.0284 2.17771C9.32684 2.38364 8.67884 2.73166 8.1277 3.19851C7.57656 3.66537 7.13496 4.24032 6.83238 4.88499C6.5298 5.52966 6.3732 6.2292 6.37305 6.93693V12.7701C6.37405 12.8711 6.39873 12.9706 6.44523 13.0611C6.49173 13.1516 6.55884 13.2308 6.64154 13.2927C6.72425 13.3547 6.8204 13.3977 6.92279 13.4187C7.02519 13.4397 7.13118 13.438 7.23282 13.4139C8.26404 13.1762 8.72022 12.4763 8.84615 11.5128L8.84666 8.32944Z"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.7324 6.7379V5.14673"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M10.084 6.78817V5.14673"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M13.3809 6.7379V5.14673"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.7377 3.15747C11.1964 3.15747 10.6603 3.26039 10.1601 3.46036C9.6599 3.66032 9.20543 3.95341 8.82263 4.32289C8.43983 4.69238 8.13619 5.13101 7.92905 5.61375C7.72191 6.09649 7.61534 6.61388 7.6154 7.13638V7.93196C6.43802 7.93196 6.51844 9.92142 7.82124 9.92142H7.82478C8.11793 10.8281 8.73839 11.6033 9.57344 12.106C10.4085 12.6087 11.4027 12.8057 12.3754 12.6611C13.3482 12.5164 14.2348 12.0398 14.8744 11.3178C15.5139 10.5958 15.8638 9.67641 15.8606 8.72657V7.1354C15.8605 6.61295 15.7538 6.09562 15.5466 5.61296C15.3394 5.1303 15.0357 4.69176 14.6528 4.32238C14.27 3.95299 13.8155 3.66 13.3153 3.46012C12.8152 3.26025 12.2791 3.15741 11.7377 3.15747V3.15747Z"
                  fill="#FFCEBF"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M10.502 8.03154C10.502 8.16345 10.5562 8.28996 10.6529 8.38323C10.7495 8.47651 10.8806 8.52891 11.0173 8.52891C11.154 8.52891 11.2851 8.47651 11.3817 8.38323C11.4784 8.28996 11.5327 8.16345 11.5327 8.03154C11.5327 7.89963 11.4784 7.77313 11.3817 7.67985C11.2851 7.58658 11.154 7.53418 11.0173 7.53418C10.8806 7.53418 10.7495 7.58658 10.6529 7.67985C10.5562 7.77313 10.502 7.89963 10.502 8.03154Z"
                  fill="#45413C"
                />
                <path
                  d="M13.5918 8.03154C13.5918 8.09686 13.6051 8.16153 13.631 8.22188C13.6569 8.28222 13.6949 8.33705 13.7427 8.38323C13.7906 8.42942 13.8474 8.46605 13.9099 8.49105C13.9725 8.51604 14.0395 8.52891 14.1072 8.52891C14.1748 8.52891 14.2418 8.51604 14.3044 8.49105C14.3669 8.46605 14.4237 8.42942 14.4716 8.38323C14.5194 8.33705 14.5574 8.28222 14.5833 8.22188C14.6092 8.16153 14.6225 8.09686 14.6225 8.03154C14.6225 7.96623 14.6092 7.90155 14.5833 7.84121C14.5574 7.78087 14.5194 7.72604 14.4716 7.67985C14.4237 7.63367 14.3669 7.59703 14.3044 7.57204C14.2418 7.54704 14.1748 7.53418 14.1072 7.53418C14.0395 7.53418 13.9725 7.54704 13.9099 7.57204C13.8474 7.59703 13.7906 7.63367 13.7427 7.67985C13.6949 7.72604 13.6569 7.78087 13.631 7.84121C13.6051 7.90155 13.5918 7.96623 13.5918 8.03154V8.03154Z"
                  fill="#45413C"
                />
                <path
                  d="M10.5001 9.6224C10.5001 9.70108 10.476 9.77799 10.4307 9.8434C10.3854 9.90882 10.321 9.95981 10.2457 9.98992C10.1704 10.02 10.0875 10.0279 10.0076 10.0126C9.9276 9.9972 9.85415 9.95932 9.79651 9.90368C9.73886 9.84805 9.69961 9.77717 9.6837 9.70001C9.6678 9.62284 9.67596 9.54286 9.70716 9.47017C9.73835 9.39749 9.79118 9.33536 9.85897 9.29165C9.92675 9.24794 10.0064 9.22461 10.088 9.22461C10.1973 9.22461 10.3021 9.26652 10.3794 9.34112C10.4567 9.41572 10.5001 9.5169 10.5001 9.6224V9.6224Z"
                  fill="#FFB59E"
                />
                <path
                  d="M11.5332 10.2815C11.8188 10.5219 12.1849 10.6544 12.5639 10.6544C12.9429 10.6544 13.3091 10.5219 13.5946 10.2815"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.84666 8.32944C8.84666 7.90731 9.02041 7.50247 9.32971 7.20397C9.639 6.90548 10.0585 6.73778 10.4959 6.73778H16.2827C16.3318 6.73784 16.3803 6.72771 16.425 6.70807C16.4697 6.68843 16.5095 6.65974 16.5416 6.62396C16.5738 6.58817 16.5977 6.54612 16.6115 6.50066C16.6254 6.45521 16.629 6.4074 16.622 6.36049C16.479 5.26738 15.9688 4.24961 15.1695 3.46289C14.3702 2.67617 13.3258 2.16384 12.1962 2.00429C11.4691 1.91265 10.73 1.97177 10.0284 2.17771C9.32684 2.38364 8.67884 2.73166 8.1277 3.19851C7.57656 3.66537 7.13496 4.24032 6.83238 4.88499C6.5298 5.52966 6.3732 6.2292 6.37305 6.93693V12.7701C6.37405 12.8711 6.39873 12.9706 6.44523 13.0611C6.49173 13.1516 6.55884 13.2308 6.64154 13.2927C6.72425 13.3547 6.8204 13.3977 6.92279 13.4187C7.02519 13.4397 7.13118 13.438 7.23282 13.4139C8.26404 13.1762 8.72022 12.4763 8.84615 11.5128L8.84666 8.32944Z"
                  fill="#FFC44D"
                />
                <path
                  d="M11.3202 3.55502C12.3083 3.55792 13.2843 3.76563 14.1821 4.1641C15.0798 4.56257 15.8784 5.14251 16.5238 5.86466C16.2863 4.80434 15.6945 3.84866 14.8394 3.14454C13.9843 2.44042 12.9133 2.02685 11.7909 1.9674C10.6685 1.90796 9.55701 2.20594 8.62721 2.81552C7.69742 3.42511 7.00082 4.31256 6.64453 5.34143C7.91286 4.19667 9.5836 3.55833 11.3202 3.55502V3.55502Z"
                  fill="#FFDB94"
                />
                <path
                  d="M8.84666 8.32944C8.84666 7.90731 9.02041 7.50247 9.32971 7.20397C9.639 6.90548 10.0585 6.73778 10.4959 6.73778H16.2827C16.3318 6.73784 16.3803 6.72771 16.425 6.70807C16.4697 6.68843 16.5095 6.65974 16.5416 6.62396C16.5738 6.58817 16.5977 6.54612 16.6115 6.50066C16.6254 6.45521 16.629 6.4074 16.622 6.36049C16.479 5.26738 15.9688 4.24961 15.1695 3.46289C14.3702 2.67617 13.3258 2.16384 12.1962 2.00429C11.4691 1.91265 10.73 1.97177 10.0284 2.17771C9.32684 2.38364 8.67884 2.73166 8.1277 3.19851C7.57656 3.66537 7.13496 4.24032 6.83238 4.88499C6.5298 5.52966 6.3732 6.2292 6.37305 6.93693V12.7701C6.37405 12.8711 6.39873 12.9706 6.44523 13.0611C6.49173 13.1516 6.55884 13.2308 6.64154 13.2927C6.72425 13.3547 6.8204 13.3977 6.92279 13.4187C7.02519 13.4397 7.13118 13.438 7.23282 13.4139C8.26404 13.1762 8.72022 12.4763 8.84615 11.5128L8.84666 8.32944Z"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.7324 6.7379V5.14673"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M10.084 6.78817V5.14673"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M13.3809 6.7379V5.14673"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <div>
                <h5 class="blue-text">Services</h5>
              </div>
              <br />
            </v-card>
          </div>
        </div>

        <div class="col-lg-12">
          <h4 class="blue-text text-left mb-3">CARE ADMINISTRATION</h4>
          <div style="display: flex; gap: 0.5rem">
            <v-card
              style="cursor: pointer; width: 50%; text-align: center"
              class="d-block d-lg-none"
            >
              <br />
              <svg
                width="61"
                height="62"
                @click="virtualVisit"
                viewBox="0 0 47 46"
                fill="none"
                class="mt-1"
              >
                <path
                  d="M1 23.2714C1 29.1782 3.37053 34.843 7.5901 39.0197C11.8097 43.1964 17.5326 45.5428 23.5 45.5428C29.4674 45.5428 35.1903 43.1964 39.4099 39.0197C43.6295 34.843 46 29.1782 46 23.2714C46 17.3647 43.6295 11.6998 39.4099 7.52315C35.1903 3.34645 29.4674 1 23.5 1C17.5326 1 11.8097 3.34645 7.5901 7.52315C3.37053 11.6998 1 17.3647 1 23.2714Z"
                  fill="#E8F4FA"
                  stroke="#DAEDF7"
                  stroke-width="0.8"
                />
                <path
                  d="M29.7593 39.808C29.6022 37.2163 30.3294 34.6475 31.8242 32.5141C31.9359 32.3565 32.078 32.2223 32.2423 32.1193C32.4067 32.0164 32.59 31.9466 32.7817 31.9142C32.9734 31.8817 33.1697 31.8872 33.3592 31.9302C33.5488 31.9733 33.7279 32.0531 33.8861 32.165C34.0444 32.2769 34.1786 32.4187 34.2812 32.5823C34.3838 32.7459 34.4526 32.9279 34.4837 33.118C34.5147 33.308 34.5075 33.5023 34.4623 33.6895C34.4172 33.8768 34.335 34.0533 34.2205 34.2089C33.1335 35.7639 32.5951 37.6304 32.6888 39.519C32.7276 39.9038 32.6104 40.288 32.363 40.5872C32.1155 40.8864 31.7582 41.0761 31.3695 41.1145C30.9808 41.1529 30.5926 41.0369 30.2903 40.792C29.988 40.547 29.7964 40.1933 29.7576 39.8085L29.7593 39.808Z"
                  fill="#D18660"
                  stroke="#45413C"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M27.0111 38.7296C26.8545 36.1377 27.5823 33.5689 29.0778 31.4357C29.1894 31.2781 29.3315 31.1439 29.4958 31.041C29.6602 30.938 29.8435 30.8683 30.0352 30.8358C30.2269 30.8034 30.4232 30.8088 30.6128 30.8518C30.8023 30.8949 30.9814 30.9747 31.1396 31.0866C31.2979 31.1985 31.4322 31.3404 31.5347 31.5039C31.6373 31.6675 31.7061 31.8496 31.7372 32.0396C31.7683 32.2296 31.761 32.4239 31.7158 32.6111C31.6707 32.7984 31.5885 32.9749 31.474 33.1306C30.3871 34.6856 29.8485 36.5519 29.9418 38.4406C29.9623 38.6317 29.9445 38.825 29.8893 39.0093C29.8341 39.1936 29.7426 39.3653 29.6201 39.5145C29.4975 39.6636 29.3464 39.7873 29.1754 39.8784C29.0044 39.9696 28.8169 40.0263 28.6237 40.0454C28.4304 40.0645 28.2353 40.0455 28.0494 39.9897C27.8636 39.9338 27.6908 39.8421 27.5409 39.7199C27.391 39.5976 27.2671 39.4472 27.1761 39.2774C27.0852 39.1075 27.0291 38.9215 27.0111 38.7301V38.7296Z"
                  fill="#D18660"
                  stroke="#45413C"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M24.4037 37.7723C24.2471 35.1805 24.9749 32.6117 26.4703 30.4785C26.5828 30.3227 26.7251 30.1904 26.8893 30.0892C27.0534 29.9879 27.236 29.9196 27.4268 29.8882C27.6176 29.8568 27.8128 29.8628 28.0012 29.9061C28.1896 29.9493 28.3675 30.0289 28.5249 30.1402C28.6822 30.2515 28.8159 30.3925 28.9182 30.5549C29.0205 30.7173 29.0895 30.8982 29.1212 31.087C29.153 31.2758 29.1468 31.469 29.1031 31.6555C29.0594 31.842 28.979 32.0181 28.8666 32.1739C27.7797 33.7287 27.2411 35.5949 27.3343 37.4833C27.3541 37.6741 27.3356 37.8668 27.28 38.0504C27.2244 38.234 27.1327 38.405 27.0102 38.5535C26.8878 38.7021 26.7369 38.8252 26.5663 38.9159C26.3956 39.0067 26.2086 39.0632 26.0159 39.0823C25.8232 39.1013 25.6285 39.0826 25.4432 39.0271C25.2578 38.9716 25.0852 38.8805 24.9355 38.7589C24.7857 38.6373 24.6617 38.4877 24.5704 38.3186C24.4792 38.1495 24.4225 37.9642 24.4037 37.7734V37.7723Z"
                  fill="#D18660"
                  stroke="#45413C"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M42.293 37.2379C40.943 32.7892 38.5619 28.5811 34.6644 26.9324C32.0718 25.8356 29.2132 25.5405 26.5992 26.5878L25.0085 27.2247C24.6773 27.3573 24.4063 27.6048 24.246 27.9209C24.0858 28.2369 24.0473 28.5999 24.1378 28.942C24.2283 29.2841 24.4416 29.5818 24.7377 29.7796C25.0339 29.9773 25.3927 30.0615 25.7471 30.0165C26.1408 29.9402 26.1487 30.1306 26.3928 30.801C29.2616 35.6545 30.1357 37.0793 32.4177 40.656C33.2907 41.881 34.3865 42.4378 35.0615 43.5469C37.6927 41.7056 40.117 39.5905 42.293 37.2379Z"
                  fill="#D18660"
                />
                <path
                  d="M42.2931 37.238C40.9431 32.7892 38.5621 28.5811 34.6645 26.9324C32.0719 25.8356 29.2133 25.5405 26.5994 26.5878L25.0086 27.2247C24.6469 27.3704 24.3583 27.6522 24.2062 28.0083C24.0541 28.3643 24.051 28.7656 24.1975 29.1239C24.2216 29.183 24.2496 29.2405 24.2813 29.296L25.9778 28.5387C27.1731 27.9799 28.4711 27.6683 29.7923 27.6231C31.1135 27.5779 32.4301 27.8001 33.6616 28.2759C37.4303 29.8544 39.5943 34.2664 40.7249 38.8549"
                  fill="#E09F7E"
                />
                <path
                  d="M35.0178 35.0301C33.9852 34.5197 33.0558 33.8264 32.2756 32.9845C31.9161 32.5975 33.1137 33.9528 28.7363 28.9812C36.0595 27.7167 36.3256 35.6877 35.0178 35.0301Z"
                  fill="#BD704A"
                />
                <path
                  d="M42.293 37.2374C40.943 32.7887 38.5619 28.5811 34.6644 26.9324C32.0718 25.8356 29.2132 25.5405 26.5992 26.5878L25.0085 27.2247C24.6773 27.3573 24.4063 27.6048 24.246 27.9209C24.0858 28.2369 24.0473 28.5999 24.1378 28.942C24.2283 29.2841 24.4416 29.5818 24.7377 29.7796C25.0339 29.9773 25.3927 30.0615 25.7471 30.0165C26.1408 29.9402 26.1487 30.1306 26.3928 30.801C29.2616 35.6545 30.1357 37.0793 32.4177 40.656C33.2907 41.881 34.3865 42.4378 35.0615 43.5469L42.293 37.2374ZM35.0176 35.0314C33.985 34.5206 33.0556 33.8269 32.2754 32.9847C31.916 32.5977 33.1135 33.9529 28.7362 28.9814C36.0594 27.7169 36.3254 35.6879 35.0176 35.0303V35.0314Z"
                  stroke="#45413C"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.3828 6.5802H34.2708V35.9428H12.3828V6.5802Z"
                  fill="white"
                />
                <path
                  d="M34.2708 11.574V7.33075C34.2708 7.2321 34.2512 7.13441 34.213 7.04327C34.1748 6.95214 34.1189 6.86935 34.0483 6.79964C33.9778 6.72993 33.8941 6.67467 33.802 6.63701C33.7098 6.59936 33.6111 6.58005 33.5114 6.5802H13.1411C12.94 6.5802 12.7471 6.65928 12.6049 6.80003C12.4627 6.94079 12.3828 7.1317 12.3828 7.33075V11.574H34.2708Z"
                  fill="#FF6242"
                />
                <path
                  d="M33.5114 6.5802H13.1411C12.94 6.5802 12.7471 6.65928 12.6049 6.80003C12.4627 6.94079 12.3828 7.13169 12.3828 7.33075V9.58351C12.3828 9.38445 12.4627 9.19355 12.6049 9.05279C12.7471 8.91204 12.94 8.83296 13.1411 8.83296H33.5114C33.7125 8.83296 33.9054 8.91204 34.0476 9.05279C34.1898 9.19355 34.2697 9.38445 34.2697 9.58351V7.33075C34.2697 7.23219 34.2501 7.13459 34.212 7.04353C34.1739 6.95247 34.118 6.86973 34.0476 6.80003C33.9772 6.73034 33.8936 6.67505 33.8016 6.63733C33.7096 6.59961 33.611 6.5802 33.5114 6.5802Z"
                  fill="#FF866E"
                />
                <path
                  d="M12.3828 6.5802H34.2708V35.9428H12.3828V6.5802Z"
                  stroke="#45413C"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M20.8047 16.9625H24.8417"
                  stroke="#627B8C"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M20.8047 18.9602H29.8879"
                  stroke="#627B8C"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M20.8047 20.9584H27.3724"
                  stroke="#627B8C"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M20.8047 26.9524H25.8509"
                  stroke="#627B8C"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M20.8047 28.9501H23.4726"
                  stroke="#627B8C"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M20.8047 30.9478H23.3078"
                  stroke="#627B8C"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M15.6309 20.0861C15.6309 20.3087 15.6976 20.5264 15.8225 20.7115C15.9475 20.8967 16.1252 21.041 16.333 21.1262C16.5408 21.2114 16.7695 21.2337 16.9901 21.1902C17.2108 21.1468 17.4134 21.0396 17.5725 20.8821C17.7315 20.7247 17.8399 20.5241 17.8838 20.3057C17.9276 20.0873 17.9051 19.8609 17.819 19.6552C17.7329 19.4495 17.5872 19.2737 17.4001 19.15C17.2131 19.0263 16.9932 18.9602 16.7682 18.9602C16.5433 18.9602 16.3233 18.8942 16.1363 18.7705C15.9492 18.6467 15.8035 18.4709 15.7174 18.2651C15.6313 18.0594 15.6088 17.833 15.6528 17.6146C15.6967 17.3962 15.8051 17.1956 15.9642 17.0382C16.1233 16.8807 16.326 16.7736 16.5467 16.7302C16.7674 16.6868 16.9961 16.7092 17.2039 16.7945C17.4117 16.8798 17.5893 17.0242 17.7142 17.2094C17.8391 17.3946 17.9057 17.6123 17.9056 17.835"
                  stroke="#FF6242"
                  stroke-width="1.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16.7695 16.7091V15.9586"
                  stroke="#FF6242"
                  stroke-width="1.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16.7695 21.9626V21.212"
                  stroke="#FF6242"
                  stroke-width="1.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M15.6309 30.076C15.6307 30.2987 15.6974 30.5164 15.8223 30.7016C15.9472 30.8869 16.1248 31.0313 16.3326 31.1165C16.5404 31.2018 16.7691 31.2242 16.9898 31.1808C17.2104 31.1375 17.4132 31.0303 17.5723 30.8729C17.7314 30.7154 17.8398 30.5148 17.8837 30.2964C17.9276 30.078 17.9052 29.8516 17.8191 29.6459C17.733 29.4401 17.5872 29.2643 17.4002 29.1405C17.2131 29.0168 16.9932 28.9508 16.7682 28.9508C16.5433 28.9508 16.3234 28.8847 16.1363 28.761C15.9493 28.6373 15.8035 28.4615 15.7174 28.2558C15.6314 28.05 15.6088 27.8237 15.6527 27.6053C15.6966 27.3869 15.8049 27.1863 15.964 27.0288C16.1231 26.8714 16.3257 26.7642 16.5463 26.7207C16.767 26.6773 16.9957 26.6996 17.2035 26.7848C17.4113 26.87 17.5889 27.0143 17.7139 27.1994C17.8389 27.3846 17.9056 27.6023 17.9056 27.8249"
                  stroke="#FF6242"
                  stroke-width="1.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16.7695 26.6983V25.9478"
                  stroke="#FF6242"
                  stroke-width="1.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16.7695 31.9525V31.2019"
                  stroke="#FF6242"
                  stroke-width="1.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.3828 11.5739H34.2708"
                  stroke="#45413C"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M32.3163 40.4989C30.0838 36.9995 29.2051 35.5669 26.3116 30.6705C26.1397 30.4395 26.0304 30.1688 25.9939 29.8841C25.9575 29.5995 25.9952 29.3103 26.1035 29.0441C26.2126 28.832 26.3725 28.6495 26.5692 28.5126C26.766 28.3757 26.9936 28.2886 27.2322 28.2588C27.4708 28.2291 27.7132 28.2577 27.9381 28.3421C28.1629 28.4265 28.3635 28.5641 28.5223 28.7429L28.7321 28.9812C33.1286 33.9745 31.9147 32.6003 32.2713 32.9845C33.0521 33.8265 33.982 34.5199 35.0152 35.0301"
                  fill="#D18660"
                />
                <path
                  d="M35.0595 35.0509C32.4051 36.9579 28.7511 32.0254 26.752 28.4079C27.0429 28.2609 27.3751 28.2139 27.696 28.2744C28.0169 28.3348 28.3084 28.4994 28.5244 28.742L28.7342 28.9803C33.1307 33.9736 31.9168 32.5994 32.2735 32.9836C33.0542 33.8256 33.9842 34.5189 35.0173 35.0292"
                  fill="#E09F7E"
                />
                <path
                  d="M32.3163 40.4989C30.0838 36.9995 29.2051 35.5669 26.3116 30.6705C26.1397 30.4395 26.0304 30.1688 25.9939 29.8841C25.9575 29.5995 25.9952 29.3103 26.1035 29.0441C26.2126 28.832 26.3725 28.6495 26.5692 28.5126C26.766 28.3757 26.9936 28.2886 27.2322 28.2588C27.4708 28.2291 27.7132 28.2577 27.9381 28.3421C28.1629 28.4265 28.3635 28.5641 28.5223 28.7429L28.7321 28.9812C33.1286 33.9745 31.9147 32.6003 32.2713 32.9845C33.0521 33.8265 33.982 34.5199 35.0152 35.0301"
                  stroke="#45413C"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <div>
                <h5 class="blue-text">Visit Passes</h5>
              </div>
              <br />
            </v-card>
            <v-card
              style="cursor: pointer; width: 50%; text-align: center"
              class="d-none d-lg-block"
            >
              <br />
              <svg
                width="61"
                height="62"
                @click="$router.push('/member/visit-passes')"
                viewBox="0 0 47 46"
                fill="none"
                class="mt-1"
              >
                <path
                  d="M1 23.2714C1 29.1782 3.37053 34.843 7.5901 39.0197C11.8097 43.1964 17.5326 45.5428 23.5 45.5428C29.4674 45.5428 35.1903 43.1964 39.4099 39.0197C43.6295 34.843 46 29.1782 46 23.2714C46 17.3647 43.6295 11.6998 39.4099 7.52315C35.1903 3.34645 29.4674 1 23.5 1C17.5326 1 11.8097 3.34645 7.5901 7.52315C3.37053 11.6998 1 17.3647 1 23.2714Z"
                  fill="#E8F4FA"
                  stroke="#DAEDF7"
                  stroke-width="0.8"
                />
                <path
                  d="M29.7593 39.808C29.6022 37.2163 30.3294 34.6475 31.8242 32.5141C31.9359 32.3565 32.078 32.2223 32.2423 32.1193C32.4067 32.0164 32.59 31.9466 32.7817 31.9142C32.9734 31.8817 33.1697 31.8872 33.3592 31.9302C33.5488 31.9733 33.7279 32.0531 33.8861 32.165C34.0444 32.2769 34.1786 32.4187 34.2812 32.5823C34.3838 32.7459 34.4526 32.9279 34.4837 33.118C34.5147 33.308 34.5075 33.5023 34.4623 33.6895C34.4172 33.8768 34.335 34.0533 34.2205 34.2089C33.1335 35.7639 32.5951 37.6304 32.6888 39.519C32.7276 39.9038 32.6104 40.288 32.363 40.5872C32.1155 40.8864 31.7582 41.0761 31.3695 41.1145C30.9808 41.1529 30.5926 41.0369 30.2903 40.792C29.988 40.547 29.7964 40.1933 29.7576 39.8085L29.7593 39.808Z"
                  fill="#D18660"
                  stroke="#45413C"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M27.0111 38.7296C26.8545 36.1377 27.5823 33.5689 29.0778 31.4357C29.1894 31.2781 29.3315 31.1439 29.4958 31.041C29.6602 30.938 29.8435 30.8683 30.0352 30.8358C30.2269 30.8034 30.4232 30.8088 30.6128 30.8518C30.8023 30.8949 30.9814 30.9747 31.1396 31.0866C31.2979 31.1985 31.4322 31.3404 31.5347 31.5039C31.6373 31.6675 31.7061 31.8496 31.7372 32.0396C31.7683 32.2296 31.761 32.4239 31.7158 32.6111C31.6707 32.7984 31.5885 32.9749 31.474 33.1306C30.3871 34.6856 29.8485 36.5519 29.9418 38.4406C29.9623 38.6317 29.9445 38.825 29.8893 39.0093C29.8341 39.1936 29.7426 39.3653 29.6201 39.5145C29.4975 39.6636 29.3464 39.7873 29.1754 39.8784C29.0044 39.9696 28.8169 40.0263 28.6237 40.0454C28.4304 40.0645 28.2353 40.0455 28.0494 39.9897C27.8636 39.9338 27.6908 39.8421 27.5409 39.7199C27.391 39.5976 27.2671 39.4472 27.1761 39.2774C27.0852 39.1075 27.0291 38.9215 27.0111 38.7301V38.7296Z"
                  fill="#D18660"
                  stroke="#45413C"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M24.4037 37.7723C24.2471 35.1805 24.9749 32.6117 26.4703 30.4785C26.5828 30.3227 26.7251 30.1904 26.8893 30.0892C27.0534 29.9879 27.236 29.9196 27.4268 29.8882C27.6176 29.8568 27.8128 29.8628 28.0012 29.9061C28.1896 29.9493 28.3675 30.0289 28.5249 30.1402C28.6822 30.2515 28.8159 30.3925 28.9182 30.5549C29.0205 30.7173 29.0895 30.8982 29.1212 31.087C29.153 31.2758 29.1468 31.469 29.1031 31.6555C29.0594 31.842 28.979 32.0181 28.8666 32.1739C27.7797 33.7287 27.2411 35.5949 27.3343 37.4833C27.3541 37.6741 27.3356 37.8668 27.28 38.0504C27.2244 38.234 27.1327 38.405 27.0102 38.5535C26.8878 38.7021 26.7369 38.8252 26.5663 38.9159C26.3956 39.0067 26.2086 39.0632 26.0159 39.0823C25.8232 39.1013 25.6285 39.0826 25.4432 39.0271C25.2578 38.9716 25.0852 38.8805 24.9355 38.7589C24.7857 38.6373 24.6617 38.4877 24.5704 38.3186C24.4792 38.1495 24.4225 37.9642 24.4037 37.7734V37.7723Z"
                  fill="#D18660"
                  stroke="#45413C"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M42.293 37.2379C40.943 32.7892 38.5619 28.5811 34.6644 26.9324C32.0718 25.8356 29.2132 25.5405 26.5992 26.5878L25.0085 27.2247C24.6773 27.3573 24.4063 27.6048 24.246 27.9209C24.0858 28.2369 24.0473 28.5999 24.1378 28.942C24.2283 29.2841 24.4416 29.5818 24.7377 29.7796C25.0339 29.9773 25.3927 30.0615 25.7471 30.0165C26.1408 29.9402 26.1487 30.1306 26.3928 30.801C29.2616 35.6545 30.1357 37.0793 32.4177 40.656C33.2907 41.881 34.3865 42.4378 35.0615 43.5469C37.6927 41.7056 40.117 39.5905 42.293 37.2379Z"
                  fill="#D18660"
                />
                <path
                  d="M42.2931 37.238C40.9431 32.7892 38.5621 28.5811 34.6645 26.9324C32.0719 25.8356 29.2133 25.5405 26.5994 26.5878L25.0086 27.2247C24.6469 27.3704 24.3583 27.6522 24.2062 28.0083C24.0541 28.3643 24.051 28.7656 24.1975 29.1239C24.2216 29.183 24.2496 29.2405 24.2813 29.296L25.9778 28.5387C27.1731 27.9799 28.4711 27.6683 29.7923 27.6231C31.1135 27.5779 32.4301 27.8001 33.6616 28.2759C37.4303 29.8544 39.5943 34.2664 40.7249 38.8549"
                  fill="#E09F7E"
                />
                <path
                  d="M35.0178 35.0301C33.9852 34.5197 33.0558 33.8264 32.2756 32.9845C31.9161 32.5975 33.1137 33.9528 28.7363 28.9812C36.0595 27.7167 36.3256 35.6877 35.0178 35.0301Z"
                  fill="#BD704A"
                />
                <path
                  d="M42.293 37.2374C40.943 32.7887 38.5619 28.5811 34.6644 26.9324C32.0718 25.8356 29.2132 25.5405 26.5992 26.5878L25.0085 27.2247C24.6773 27.3573 24.4063 27.6048 24.246 27.9209C24.0858 28.2369 24.0473 28.5999 24.1378 28.942C24.2283 29.2841 24.4416 29.5818 24.7377 29.7796C25.0339 29.9773 25.3927 30.0615 25.7471 30.0165C26.1408 29.9402 26.1487 30.1306 26.3928 30.801C29.2616 35.6545 30.1357 37.0793 32.4177 40.656C33.2907 41.881 34.3865 42.4378 35.0615 43.5469L42.293 37.2374ZM35.0176 35.0314C33.985 34.5206 33.0556 33.8269 32.2754 32.9847C31.916 32.5977 33.1135 33.9529 28.7362 28.9814C36.0594 27.7169 36.3254 35.6879 35.0176 35.0303V35.0314Z"
                  stroke="#45413C"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.3828 6.5802H34.2708V35.9428H12.3828V6.5802Z"
                  fill="white"
                />
                <path
                  d="M34.2708 11.574V7.33075C34.2708 7.2321 34.2512 7.13441 34.213 7.04327C34.1748 6.95214 34.1189 6.86935 34.0483 6.79964C33.9778 6.72993 33.8941 6.67467 33.802 6.63701C33.7098 6.59936 33.6111 6.58005 33.5114 6.5802H13.1411C12.94 6.5802 12.7471 6.65928 12.6049 6.80003C12.4627 6.94079 12.3828 7.1317 12.3828 7.33075V11.574H34.2708Z"
                  fill="#FF6242"
                />
                <path
                  d="M33.5114 6.5802H13.1411C12.94 6.5802 12.7471 6.65928 12.6049 6.80003C12.4627 6.94079 12.3828 7.13169 12.3828 7.33075V9.58351C12.3828 9.38445 12.4627 9.19355 12.6049 9.05279C12.7471 8.91204 12.94 8.83296 13.1411 8.83296H33.5114C33.7125 8.83296 33.9054 8.91204 34.0476 9.05279C34.1898 9.19355 34.2697 9.38445 34.2697 9.58351V7.33075C34.2697 7.23219 34.2501 7.13459 34.212 7.04353C34.1739 6.95247 34.118 6.86973 34.0476 6.80003C33.9772 6.73034 33.8936 6.67505 33.8016 6.63733C33.7096 6.59961 33.611 6.5802 33.5114 6.5802Z"
                  fill="#FF866E"
                />
                <path
                  d="M12.3828 6.5802H34.2708V35.9428H12.3828V6.5802Z"
                  stroke="#45413C"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M20.8047 16.9625H24.8417"
                  stroke="#627B8C"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M20.8047 18.9602H29.8879"
                  stroke="#627B8C"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M20.8047 20.9584H27.3724"
                  stroke="#627B8C"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M20.8047 26.9524H25.8509"
                  stroke="#627B8C"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M20.8047 28.9501H23.4726"
                  stroke="#627B8C"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M20.8047 30.9478H23.3078"
                  stroke="#627B8C"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M15.6309 20.0861C15.6309 20.3087 15.6976 20.5264 15.8225 20.7115C15.9475 20.8967 16.1252 21.041 16.333 21.1262C16.5408 21.2114 16.7695 21.2337 16.9901 21.1902C17.2108 21.1468 17.4134 21.0396 17.5725 20.8821C17.7315 20.7247 17.8399 20.5241 17.8838 20.3057C17.9276 20.0873 17.9051 19.8609 17.819 19.6552C17.7329 19.4495 17.5872 19.2737 17.4001 19.15C17.2131 19.0263 16.9932 18.9602 16.7682 18.9602C16.5433 18.9602 16.3233 18.8942 16.1363 18.7705C15.9492 18.6467 15.8035 18.4709 15.7174 18.2651C15.6313 18.0594 15.6088 17.833 15.6528 17.6146C15.6967 17.3962 15.8051 17.1956 15.9642 17.0382C16.1233 16.8807 16.326 16.7736 16.5467 16.7302C16.7674 16.6868 16.9961 16.7092 17.2039 16.7945C17.4117 16.8798 17.5893 17.0242 17.7142 17.2094C17.8391 17.3946 17.9057 17.6123 17.9056 17.835"
                  stroke="#FF6242"
                  stroke-width="1.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16.7695 16.7091V15.9586"
                  stroke="#FF6242"
                  stroke-width="1.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16.7695 21.9626V21.212"
                  stroke="#FF6242"
                  stroke-width="1.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M15.6309 30.076C15.6307 30.2987 15.6974 30.5164 15.8223 30.7016C15.9472 30.8869 16.1248 31.0313 16.3326 31.1165C16.5404 31.2018 16.7691 31.2242 16.9898 31.1808C17.2104 31.1375 17.4132 31.0303 17.5723 30.8729C17.7314 30.7154 17.8398 30.5148 17.8837 30.2964C17.9276 30.078 17.9052 29.8516 17.8191 29.6459C17.733 29.4401 17.5872 29.2643 17.4002 29.1405C17.2131 29.0168 16.9932 28.9508 16.7682 28.9508C16.5433 28.9508 16.3234 28.8847 16.1363 28.761C15.9493 28.6373 15.8035 28.4615 15.7174 28.2558C15.6314 28.05 15.6088 27.8237 15.6527 27.6053C15.6966 27.3869 15.8049 27.1863 15.964 27.0288C16.1231 26.8714 16.3257 26.7642 16.5463 26.7207C16.767 26.6773 16.9957 26.6996 17.2035 26.7848C17.4113 26.87 17.5889 27.0143 17.7139 27.1994C17.8389 27.3846 17.9056 27.6023 17.9056 27.8249"
                  stroke="#FF6242"
                  stroke-width="1.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16.7695 26.6983V25.9478"
                  stroke="#FF6242"
                  stroke-width="1.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16.7695 31.9525V31.2019"
                  stroke="#FF6242"
                  stroke-width="1.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.3828 11.5739H34.2708"
                  stroke="#45413C"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M32.3163 40.4989C30.0838 36.9995 29.2051 35.5669 26.3116 30.6705C26.1397 30.4395 26.0304 30.1688 25.9939 29.8841C25.9575 29.5995 25.9952 29.3103 26.1035 29.0441C26.2126 28.832 26.3725 28.6495 26.5692 28.5126C26.766 28.3757 26.9936 28.2886 27.2322 28.2588C27.4708 28.2291 27.7132 28.2577 27.9381 28.3421C28.1629 28.4265 28.3635 28.5641 28.5223 28.7429L28.7321 28.9812C33.1286 33.9745 31.9147 32.6003 32.2713 32.9845C33.0521 33.8265 33.982 34.5199 35.0152 35.0301"
                  fill="#D18660"
                />
                <path
                  d="M35.0595 35.0509C32.4051 36.9579 28.7511 32.0254 26.752 28.4079C27.0429 28.2609 27.3751 28.2139 27.696 28.2744C28.0169 28.3348 28.3084 28.4994 28.5244 28.742L28.7342 28.9803C33.1307 33.9736 31.9168 32.5994 32.2735 32.9836C33.0542 33.8256 33.9842 34.5189 35.0173 35.0292"
                  fill="#E09F7E"
                />
                <path
                  d="M32.3163 40.4989C30.0838 36.9995 29.2051 35.5669 26.3116 30.6705C26.1397 30.4395 26.0304 30.1688 25.9939 29.8841C25.9575 29.5995 25.9952 29.3103 26.1035 29.0441C26.2126 28.832 26.3725 28.6495 26.5692 28.5126C26.766 28.3757 26.9936 28.2886 27.2322 28.2588C27.4708 28.2291 27.7132 28.2577 27.9381 28.3421C28.1629 28.4265 28.3635 28.5641 28.5223 28.7429L28.7321 28.9812C33.1286 33.9745 31.9147 32.6003 32.2713 32.9845C33.0521 33.8265 33.982 34.5199 35.0152 35.0301"
                  stroke="#45413C"
                  stroke-width="0.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <div>
                <h5 class="blue-text">Visit Passes</h5>
              </div>
              <br />
            </v-card>

            <v-card style="cursor: pointer; width: 50%; text-align: center">
              <br />
              <svg
                width="61"
                @click="$router.push('/member/prior-auths')"
                height="62"
                viewBox="0 0 47 46"
                fill="none"
                class="mt-1"
              >
                <path
                  d="M1 23.2714C1 29.1782 3.17322 34.843 7.04158 39.0197C10.9099 43.1964 16.1565 45.5428 21.6272 45.5428C27.0979 45.5428 32.3445 43.1964 36.2129 39.0197C40.0812 34.843 42.2545 29.1782 42.2545 23.2714C42.2545 17.3647 40.0812 11.6998 36.2129 7.52315C32.3445 3.34645 27.0979 1 21.6272 1C16.1565 1 10.9099 3.34645 7.04158 7.52315C3.17322 11.6998 1 17.3647 1 23.2714Z"
                  fill="#E8F4FA"
                  stroke="#DAEDF7"
                  stroke-width="0.48"
                />
                <path
                  d="M6.8457 8.1416H34.0319V32.8818H6.8457V8.1416Z"
                  fill="white"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M34.0319 15.6894H6.8457V9.65605C6.84564 9.4572 6.88185 9.26028 6.95229 9.07654C7.02272 8.8928 7.12599 8.72585 7.2562 8.58521C7.3864 8.44457 7.541 8.33301 7.71115 8.25689C7.88129 8.18078 8.06366 8.1416 8.24784 8.1416H32.6292C33.0012 8.1416 33.358 8.30116 33.621 8.58517C33.8841 8.86919 34.0319 9.2544 34.0319 9.65605V15.6894Z"
                  fill="#00B8F0"
                />
                <path
                  d="M32.6292 8.1416H8.24784C8.06366 8.1416 7.88129 8.18078 7.71115 8.25689C7.541 8.33301 7.3864 8.44457 7.2562 8.58521C7.12599 8.72585 7.02272 8.8928 6.95229 9.07654C6.88185 9.26028 6.84564 9.4572 6.8457 9.65605V11.7523C6.8457 11.5535 6.88197 11.3567 6.95243 11.173C7.0229 10.9893 7.12618 10.8224 7.25638 10.6819C7.38658 10.5413 7.54115 10.4298 7.71126 10.3537C7.88138 10.2776 8.06371 10.2385 8.24784 10.2385H32.6292C32.8134 10.2384 32.9958 10.2775 33.1659 10.3535C33.3361 10.4296 33.4907 10.5411 33.621 10.6817C33.7513 10.8223 33.8546 10.9892 33.9251 11.1729C33.9956 11.3566 34.0319 11.5535 34.0319 11.7523V9.65605C34.0319 9.2544 33.8841 8.86919 33.621 8.58517C33.358 8.30116 33.0012 8.1416 32.6292 8.1416Z"
                  fill="#4ACFFF"
                />
                <path
                  d="M34.0319 15.6894H6.8457V9.65605C6.84564 9.4572 6.88185 9.26028 6.95229 9.07654C7.02272 8.8928 7.12599 8.72585 7.2562 8.58521C7.3864 8.44457 7.541 8.33301 7.71115 8.25689C7.88129 8.18078 8.06366 8.1416 8.24784 8.1416H32.6292C33.0012 8.1416 33.358 8.30116 33.621 8.58517C33.8841 8.86919 34.0319 9.2544 34.0319 9.65605V15.6894Z"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M6.8457 19.8828H34.0319"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M6.8457 24.076H34.0319"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M6.8457 28.2693H34.0319"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.2832 15.6891V32.8821"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M17.7188 15.6891V32.8821"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M23.1562 15.6891V32.8815"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M28.5938 15.6891V32.8815"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M6.8457 19.8828H12.2831V24.0759H6.8457V19.8828Z"
                  fill="#FFA694"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.2832 28.2693H17.7206V32.8817H12.2832V28.2693Z"
                  fill="#DAEDF7"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M17.7188 15.6891H23.1561V19.8822H17.7188V15.6891Z"
                  fill="#DAEDF7"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  opacity="0.15"
                  d="M12.1953 36.1415C12.1953 36.4672 13.0339 36.7794 14.5266 37.0097C16.0193 37.2399 18.0438 37.3693 20.1548 37.3693C22.2658 37.3693 24.2904 37.2399 25.7831 37.0097C27.2758 36.7794 28.1144 36.4672 28.1144 36.1415C28.1144 35.8159 27.2758 35.5037 25.7831 35.2734C24.2904 35.0432 22.2658 34.9138 20.1548 34.9138C18.0438 34.9138 16.0193 35.0432 14.5266 35.2734C13.0339 35.5037 12.1953 35.8159 12.1953 36.1415Z"
                  fill="#45413C"
                />
                <path
                  d="M32.6673 23.9085V17.5232C32.6672 17.0396 32.4892 16.5758 32.1725 16.2338C31.8558 15.8918 31.4264 15.6995 30.9784 15.6992C30.5304 15.6992 30.1007 15.8914 29.7839 16.2335C29.467 16.5755 29.2891 17.0395 29.2891 17.5232V23.9085H32.6673Z"
                  fill="#FFE500"
                />
                <path
                  d="M32.6673 23.9085V17.5232C32.6672 17.0396 32.4892 16.5758 32.1725 16.2338C31.8558 15.8918 31.4264 15.6995 30.9784 15.6992V15.6992C30.5304 15.6992 30.1007 15.8914 29.7839 16.2335C29.467 16.5755 29.2891 17.0395 29.2891 17.5232V23.9085H32.6673Z"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M39.3717 35.7335C39.1758 35.5807 39.0161 35.3799 38.9058 35.1476C38.7954 34.9154 38.7376 34.6583 38.7369 34.3972V29.0126C38.7369 24.0477 35.288 20.0077 31.0491 20.0077C26.8102 20.0077 23.3619 24.0477 23.3619 29.0126V34.395C23.3611 34.6561 23.3032 34.9132 23.1927 35.1455C23.0823 35.3777 22.9226 35.5785 22.7266 35.7313L39.3717 35.7335Z"
                  fill="#FFE500"
                />
                <path
                  d="M28.7668 38.1421C28.7039 38.1424 28.6433 38.1676 28.5964 38.2128C28.5495 38.258 28.5195 38.3202 28.5121 38.3876C28.5015 38.4899 28.4962 38.5927 28.4961 38.6955C28.5056 39.4226 28.7798 40.1163 29.2594 40.6268C29.739 41.1373 30.3853 41.4235 31.0588 41.4235C31.7322 41.4235 32.3786 41.1373 32.8581 40.6268C33.3377 40.1163 33.6119 39.4226 33.6214 38.6955C33.6213 38.5927 33.616 38.4899 33.6054 38.3876C33.598 38.3202 33.568 38.258 33.5211 38.2128C33.4742 38.1676 33.4136 38.1424 33.3507 38.1421H28.7668Z"
                  fill="#FFE500"
                />
                <path
                  d="M33.4657 39.6454C33.4303 39.6244 33.3906 39.6129 33.3502 39.612H28.7663C28.7259 39.6129 28.6863 39.6244 28.6508 39.6454C28.5479 39.341 28.4955 39.0195 28.4961 38.6955C28.4962 38.5927 28.5015 38.4899 28.5121 38.3876C28.5195 38.3202 28.5495 38.258 28.5964 38.2128C28.6433 38.1676 28.7039 38.1424 28.7668 38.1421H33.3502C33.4131 38.1424 33.4737 38.1676 33.5206 38.2128C33.5675 38.258 33.5975 38.3202 33.605 38.3876C33.6155 38.4899 33.6208 38.5927 33.6209 38.6955C33.6211 39.0195 33.5685 39.341 33.4657 39.6454Z"
                  fill="#EBCB00"
                />
                <path
                  d="M28.7668 38.1421C28.7039 38.1424 28.6433 38.1676 28.5964 38.2128C28.5495 38.258 28.5195 38.3202 28.5121 38.3876C28.5015 38.4899 28.4962 38.5927 28.4961 38.6955C28.5056 39.4226 28.7798 40.1163 29.2594 40.6268C29.739 41.1373 30.3853 41.4235 31.0588 41.4235C31.7322 41.4235 32.3786 41.1373 32.8581 40.6268C33.3377 40.1163 33.6119 39.4226 33.6214 38.6955C33.6213 38.5927 33.616 38.4899 33.6054 38.3876C33.598 38.3202 33.568 38.258 33.5211 38.2128C33.4742 38.1676 33.4136 38.1424 33.3507 38.1421H28.7668Z"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M31.0466 22.3211C35.2855 22.3211 38.7344 26.3612 38.7344 31.326V29.0126C38.7344 24.0477 35.2855 20.0077 31.0466 20.0077C26.8077 20.0077 23.3594 24.0477 23.3594 29.0126V31.326C23.3594 26.3612 26.8072 22.3211 31.0466 22.3211Z"
                  fill="#FFF48C"
                />
                <path
                  d="M20.822 36.9257C20.8056 37.0031 20.7972 37.0823 20.7969 37.1617V37.1745C20.7983 37.0909 20.8067 37.0077 20.822 36.9257Z"
                  fill="#FFE500"
                />
                <path
                  d="M39.3717 35.7335C39.1758 35.5807 39.0161 35.3799 38.9058 35.1476C38.7954 34.9154 38.7376 34.6583 38.7369 34.3972V29.0126C38.7369 24.0477 35.288 20.0077 31.0491 20.0077C26.8102 20.0077 23.3619 24.0477 23.3619 29.0126V34.395C23.3611 34.6561 23.3032 34.9132 23.1927 35.1455C23.0823 35.3777 22.9226 35.5785 22.7266 35.7313L39.3717 35.7335Z"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M41.4544 37.1876C41.4545 37.3786 41.4197 37.5678 41.352 37.7442C41.2843 37.9207 41.1851 38.0811 41.06 38.2161C40.9349 38.3512 40.7864 38.4583 40.623 38.5314C40.4595 38.6044 40.2844 38.642 40.1074 38.6419H22.1458C21.7885 38.6419 21.4459 38.4887 21.1933 38.216C20.9407 37.9432 20.7988 37.5733 20.7988 37.1876C20.7988 36.8019 20.9407 36.432 21.1933 36.1592C21.4459 35.8865 21.7885 35.7333 22.1458 35.7333H40.1074C40.2844 35.7332 40.4595 35.7708 40.623 35.8438C40.7864 35.9169 40.9349 36.024 41.06 36.1591C41.1851 36.2941 41.2843 36.4545 41.352 36.631C41.4197 36.8075 41.4545 36.9966 41.4544 37.1876Z"
                  fill="#FFE500"
                />
                <path
                  d="M22.1443 36.7071H40.106C40.3842 36.7071 40.6557 36.8001 40.883 36.9734C41.1103 37.1467 41.2824 37.3917 41.3756 37.6748C41.4476 37.4553 41.4698 37.2204 41.4403 36.9897C41.4108 36.7591 41.3305 36.5394 41.2062 36.3492C41.0818 36.159 40.917 36.0038 40.7255 35.8967C40.5341 35.7895 40.3216 35.7334 40.106 35.7333H22.1443C21.9286 35.7332 21.716 35.7891 21.5244 35.8962C21.3329 36.0033 21.1679 36.1585 21.0435 36.3488C20.9191 36.539 20.8388 36.7588 20.8094 36.9896C20.78 37.2203 20.8024 37.4553 20.8747 37.6748C20.9679 37.3917 21.14 37.1467 21.3673 36.9734C21.5946 36.8001 21.866 36.7071 22.1443 36.7071Z"
                  fill="#FFF48C"
                />
                <path
                  d="M41.4544 37.1876C41.4545 37.3786 41.4197 37.5678 41.352 37.7442C41.2843 37.9207 41.1851 38.0811 41.06 38.2161C40.935 38.3512 40.7864 38.4583 40.623 38.5314C40.4595 38.6044 40.2844 38.642 40.1074 38.6419H22.1458C21.7885 38.6419 21.4459 38.4887 21.1933 38.216C20.9407 37.9432 20.7988 37.5733 20.7988 37.1876C20.7988 36.8019 20.9407 36.432 21.1933 36.1592C21.4459 35.8865 21.7885 35.7333 22.1458 35.7333H40.1074C40.2844 35.7332 40.4595 35.7708 40.623 35.8438C40.7864 35.9169 40.935 36.024 41.06 36.1591C41.1851 36.2941 41.2843 36.4545 41.352 36.631C41.4197 36.8075 41.4545 36.9966 41.4544 37.1876V37.1876Z"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.0241 10.84C11.0268 10.9486 11.0092 11.0566 10.9726 11.1578C10.9359 11.2589 10.8808 11.3511 10.8106 11.4289C10.7404 11.5067 10.6565 11.5685 10.5638 11.6108C10.4712 11.653 10.3716 11.6747 10.271 11.6747C10.1704 11.6747 10.0708 11.653 9.97812 11.6108C9.88543 11.5685 9.80152 11.5067 9.73132 11.4289C9.66113 11.3511 9.60607 11.2589 9.5694 11.1578C9.53274 11.0566 9.5152 10.9486 9.51784 10.84V5.96088C9.52297 5.7489 9.60458 5.54746 9.74526 5.39948C9.88594 5.25151 10.0746 5.1687 10.271 5.1687C10.4674 5.1687 10.656 5.25151 10.7967 5.39948C10.9374 5.54746 11.019 5.7489 11.0241 5.96088V10.84Z"
                  fill="#E0E0E0"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M17.0495 10.84C17.0521 10.9486 17.0346 11.0566 16.9979 11.1578C16.9613 11.2589 16.9062 11.3511 16.836 11.4289C16.7658 11.5067 16.6819 11.5685 16.5892 11.6108C16.4965 11.653 16.397 11.6747 16.2964 11.6747C16.1958 11.6747 16.0962 11.653 16.0035 11.6108C15.9108 11.5685 15.8269 11.5067 15.7567 11.4289C15.6865 11.3511 15.6315 11.2589 15.5948 11.1578C15.5581 11.0566 15.5406 10.9486 15.5432 10.84V5.96088C15.5484 5.7489 15.63 5.54746 15.7707 5.39948C15.9113 5.25151 16.1 5.1687 16.2964 5.1687C16.4928 5.1687 16.6814 5.25151 16.8221 5.39948C16.9628 5.54746 17.0444 5.7489 17.0495 5.96088V10.84Z"
                  fill="#E0E0E0"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M25.3347 10.84C25.3373 10.9486 25.3198 11.0566 25.2831 11.1578C25.2464 11.2589 25.1914 11.3511 25.1212 11.4289C25.051 11.5067 24.9671 11.5685 24.8744 11.6108C24.7817 11.653 24.6821 11.6747 24.5815 11.6747C24.4809 11.6747 24.3814 11.653 24.2887 11.6108C24.196 11.5685 24.1121 11.5067 24.0419 11.4289C23.9717 11.3511 23.9166 11.2589 23.88 11.1578C23.8433 11.0566 23.8258 10.9486 23.8284 10.84V5.96088C23.8335 5.7489 23.9151 5.54746 24.0558 5.39948C24.1965 5.25151 24.3851 5.1687 24.5815 5.1687C24.7779 5.1687 24.9666 5.25151 25.1073 5.39948C25.2479 5.54746 25.3295 5.7489 25.3347 5.96088V10.84Z"
                  fill="#E0E0E0"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M31.3601 10.84C31.3627 10.9486 31.3452 11.0566 31.3085 11.1578C31.2718 11.2589 31.2168 11.3511 31.1466 11.4289C31.0764 11.5067 30.9925 11.5685 30.8998 11.6108C30.8071 11.653 30.7075 11.6747 30.6069 11.6747C30.5063 11.6747 30.4067 11.653 30.3141 11.6108C30.2214 11.5685 30.1375 11.5067 30.0673 11.4289C29.9971 11.3511 29.942 11.2589 29.9053 11.1578C29.8687 11.0566 29.8511 10.9486 29.8538 10.84V5.96088C29.8589 5.7489 29.9405 5.54746 30.0812 5.39948C30.2219 5.25151 30.4105 5.1687 30.6069 5.1687C30.8033 5.1687 30.992 5.25151 31.1326 5.39948C31.2733 5.54746 31.3549 5.7489 31.3601 5.96088V10.84Z"
                  fill="#E0E0E0"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M33.3164 26.0198C33.3164 27.8356 33.9845 29.5771 35.1737 30.8612C36.363 32.1452 37.9759 32.8665 39.6577 32.8665C41.3396 32.8665 42.9525 32.1452 44.1417 30.8612C45.331 29.5771 45.9991 27.8356 45.9991 26.0198C45.9991 24.2039 45.331 22.4624 44.1417 21.1783C42.9525 19.8943 41.3396 19.173 39.6577 19.173C37.9759 19.173 36.363 19.8943 35.1737 21.1783C33.9845 22.4624 33.3164 24.2039 33.3164 26.0198Z"
                  fill="#FF6242"
                />
                <path
                  d="M45.8597 27.4512C45.5558 25.9186 44.7742 24.5449 43.6454 23.5594C42.5167 22.574 41.1089 22.0363 39.6573 22.0363C38.2057 22.0363 36.798 22.574 35.6692 23.5594C34.5404 24.5449 33.7588 25.9186 33.455 27.4512C33.257 26.4528 33.2683 25.4192 33.4881 24.4261C33.7079 23.4331 34.1305 22.5056 34.7251 21.7116C35.3197 20.9177 36.0712 20.2773 36.9246 19.8374C37.778 19.3975 38.7117 19.1692 39.6573 19.1692C40.603 19.1692 41.5367 19.3975 42.3901 19.8374C43.2435 20.2773 43.9949 20.9177 44.5895 21.7116C45.1841 22.5056 45.6068 23.4331 45.8265 24.4261C46.0463 25.4192 46.0576 26.4528 45.8597 27.4512Z"
                  fill="#FF866E"
                />
                <path
                  d="M33.3164 26.0198C33.3164 27.8356 33.9845 29.5771 35.1737 30.8612C36.363 32.1452 37.9759 32.8665 39.6577 32.8665C41.3396 32.8665 42.9525 32.1452 44.1417 30.8612C45.331 29.5771 45.9991 27.8356 45.9991 26.0198C45.9991 24.2039 45.331 22.4624 44.1417 21.1783C42.9525 19.8943 41.3396 19.173 39.6577 19.173C37.9759 19.173 36.363 19.8943 35.1737 21.1783C33.9845 22.4624 33.3164 24.2039 33.3164 26.0198V26.0198Z"
                  stroke="#45413C"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M39.656 26.4719C39.4752 26.4719 39.2995 26.4068 39.1568 26.2869C39.0141 26.167 38.9125 25.9991 38.8681 25.8099L38.4488 24.0282C38.3402 23.6513 38.254 23.2673 38.191 22.8784C38.1772 22.662 38.2047 22.4448 38.2718 22.2403C38.339 22.0358 38.4443 21.8484 38.5814 21.6897C38.7184 21.531 38.8842 21.4044 39.0684 21.3178C39.2526 21.2312 39.4513 21.1863 39.6523 21.186C39.8532 21.1858 40.0521 21.2301 40.2365 21.3162C40.4209 21.4024 40.587 21.5286 40.7244 21.6869C40.8617 21.8452 40.9675 22.0323 41.0352 22.2366C41.1028 22.4409 41.1308 22.6581 41.1175 22.8745C41.0555 23.2654 40.9694 23.6514 40.8596 24.0299L40.4404 25.8116C40.3958 25.9999 40.2946 26.1669 40.1527 26.2864C40.0107 26.4059 39.836 26.4712 39.656 26.4719Z"
                  fill="white"
                  stroke="#E04122"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M39.6551 30.9318C39.365 30.9319 39.0813 30.8391 38.84 30.6651C38.5986 30.4912 38.4105 30.2438 38.2994 29.9544C38.1882 29.665 38.1591 29.3465 38.2156 29.0392C38.2721 28.7319 38.4117 28.4496 38.6168 28.228C38.822 28.0064 39.0833 27.8554 39.3679 27.7942C39.6525 27.733 39.9475 27.7642 40.2156 27.884C40.4837 28.0038 40.7129 28.2068 40.8742 28.4672C41.0355 28.7276 41.1216 29.0339 41.1217 29.3472C41.1213 29.7671 40.9667 30.1697 40.6918 30.4668C40.4169 30.7638 40.0441 30.931 39.6551 30.9318Z"
                  fill="white"
                  stroke="#E04122"
                  stroke-width="0.48"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <div>
                <h5 class="blue-text">Prior Auths</h5>
              </div>
              <br />
            </v-card>
          </div>
        </div>
      </div>
    </div>
    <!-- <v-row justify="center">
            <v-dialog v-model.trim="dialog" scrollable max-width="450px" fullscreen>
                <v-card class="pt-3">
                    <v-card-text class="pb-16">
                        <div class="row">
                            <div class="col-12">
                                <v-select
                                        placeholder="User"
                                        required
                                        solo
                                        :items="[ { text:'Bill Smith' }, { text:'James Smithson ' },{ text:'Brian James '}, ]"
                                ></v-select>
                            </div>
                        </div>
                        <div style="background:#4072B7;padding: 1rem 3rem">
                            <input type="text" class="form-control" placeholder="Search"
                                   style="width: 100%;background: white;height: 40px;border-radius: 3rem;padding-left: 1rem;outline: none">
                        </div>
                        <div class="row mt-1">
                            <div class="col-4">
                                  <v-btn text x-large color="secondary"
                                    :style="checkIfTabIsActive('pending')" outlined style="width: 100%; border-radius: 0px !important"
                                    @click="changeActiveTab('pending')" class="btn-group-pac">
                                    Pending
                               </v-btn>
                            </div>
                            <div class="col-4">
                                <v-btn  text x-large color="secondary"
                                    :style="checkIfTabIsActive('active')" outlined style="width: 100%; border-radius: 0px !important"
                                    @click="changeActiveTab('active')" class="btn-group-pac">
                                    Active
                              </v-btn>
                            </div>
                            <div class="col-4">
                                 <v-btn  text x-large color="secondary"
                                    :style="checkIfTabIsActive('completed')" outlined style="width: 100%; border-radius: 0px !important"
                                    @click="changeActiveTab('completed')" class="btn-group-pac">
                                    Completed
                              </v-btn>
                            </div>
                        </div>
                        <div class="mt-5" v-for="(vp,index) in visitPasses" :key="index" style="box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;;padding:0.6rem">
                            <div class="pt-2" v-if="activeTab === 'pending'">
                                <h2>Visit Pass - <span style="color: red">Pending</span></h2>
                            </div>
                            <div  class="pt-2" v-if="activeTab === 'active'">
                                <h2>Visit Pass - <span style="color: green">Active</span></h2>
                            </div>
                            <div  class="pt-2" v-if="activeTab === 'completed'">
                                <h2 >Visit Pass - <span style="color: grey">Completed</span></h2>
                            </div>
                            <hr class="mt-3">
                            <div style="display: flex;justify-content: space-between">
                                <p>Group #: <b>{{vp.groupId}}</b></p>
                                <p>Payer ID: <b>{{vp.payerId}}</b></p>
                            </div>
                            <div>
                                <p>Member: <b>{{vp.member}}</b></p>
                            </div>
                            <div>
                                <p>Member ID: <b>{{vp.memberId}}</b></p>
                            </div>
                            <hr class="mt-3">
                            <div>
                                <p>Provider: <a href="">{{vp.provider}}</a></p>
                            </div>
                            <div>
                                <p>Prior Auth #: <b>{{vp.priorAuth}}</b></p>
                            </div>
                            <div>
                                <p>Service Type: <b>{{vp.serviceType}}</b></p>
                            </div>
                            <div>
                                <p>Service: <b>{{vp.service}}</b></p>
                            </div>
                            <hr class="mt-3">
                            <div>
                                <p>Member's Capay: <b>{{vp.membersCapay}}</b></p>
                            </div>
                            <div>
                                <p>Memeber's Deductible: <b>{{vp.memberDeductible}}</b></p>
                            </div>
                            <hr class="mt-3">
                            <div class="mt-5">
                                <h4 class="text-underline text-center" style="color:red">
                                    IMPORTANT MESSAGE
                                </h4>
                            </div>
                            <div class="mt-4">
                                <h4 class=" text-center" style="color:red">
                                   DO NOT PRESENT YOUR INSURANCE CARD TO THE PROVIDER
                                </h4>
                            </div>
                            <div class="mt-4">
                                <h4 class=" text-center" style="color:red">
                                    ONLY PRESENT YOUR VISIT PASS
                                </h4>
                            </div>
                            <div class="mt-4">
                                <v-btn block class="blue-buttons">Check Prior Auth Status</v-btn>
                            </div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row> -->
    <v-dialog
      hide-overlay
      v-model.trim="successDialog"
      height="293"
      width="400"
      content-class="modal-member-check"
    >
      <v-card>
        <v-card-text>
          <div class="col-md-12">
            <div class="row text-center justify-center">
              <h3 class="text-center mt-5 mb-5 text-underline black--text">
                Member Eligibility Check
              </h3>
            </div>
          </div>
          <div class="col-md-12 text-center mt-3">
            <div
              class="green-success-modal pointer"
              @click="
                $router.push('/member/home/wizard'),
                  (successDialog = false),
                  (showOverlay = false)
              "
            >
              <svg
                width="44"
                height="44"
                viewBox="0 0 54 54"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M48.5241 20.7069C48.3196 21.4829 47.9038 22.1817 47.3262 22.7203L45.166 24.7383C44.7439 25.1323 44.4066 25.6134 44.1756 26.1507C43.9447 26.6879 43.8254 27.2693 43.8254 27.8573C43.8254 28.4452 43.9447 29.0266 44.1756 29.5639C44.4066 30.1012 44.7439 30.5823 45.166 30.9763L47.3262 32.9943C47.9495 33.5756 48.3833 34.3423 48.5682 35.189C48.753 36.0357 48.6797 36.9208 48.3584 37.7227C48.0371 38.5246 47.4835 39.2039 46.7738 39.6672C46.064 40.1305 45.233 40.3551 44.3948 40.3102L41.4878 40.1562C40.9203 40.1265 40.353 40.2202 39.8227 40.4314C39.2923 40.6426 38.8108 40.9665 38.409 41.3822C38.0073 41.7979 37.6944 42.2961 37.4904 42.8446C37.2865 43.3932 37.1961 43.9799 37.2252 44.5669L37.3741 47.5732C37.4191 48.4409 37.2029 49.3018 36.7552 50.0372C36.3074 50.7725 35.6503 51.3462 34.8741 51.6792C34.098 52.0123 33.2411 52.0882 32.4215 51.8966C31.6019 51.705 30.86 51.2553 30.2978 50.6094L28.3465 48.3753C27.9656 47.9389 27.5003 47.59 26.9808 47.3512C26.4613 47.1123 25.8991 46.9889 25.3306 46.9889C24.7621 46.9889 24.1999 47.1123 23.6804 47.3512C23.1609 47.59 22.6957 47.9389 22.3148 48.3753L20.3634 50.6094C19.8011 51.2544 19.0593 51.7033 18.2401 51.8943C17.4209 52.0854 16.5646 52.0092 15.789 51.6763C15.0134 51.3435 14.3566 50.7702 13.909 50.0354C13.4614 49.3006 13.2449 48.4404 13.2894 47.5732L13.445 44.5669C13.474 43.9797 13.3836 43.3928 13.1795 42.8441C12.9755 42.2953 12.6623 41.797 12.2603 41.3813C11.8584 40.9656 11.3765 40.6417 10.8459 40.4307C10.3153 40.2197 9.74781 40.1261 9.18008 40.1562L6.27311 40.3102C5.43493 40.3551 4.60385 40.1305 3.8941 39.6672C3.18436 39.2039 2.63079 38.5246 2.30948 37.7227C1.98818 36.9208 1.91491 36.0357 2.09974 35.189C2.28457 34.3423 2.71844 33.5756 3.3417 32.9943L5.50192 30.9763C5.92395 30.5823 6.26134 30.1012 6.49226 29.5639C6.72319 29.0266 6.8425 28.4452 6.8425 27.8573C6.8425 27.2693 6.72319 26.6879 6.49226 26.1507C6.26134 25.6134 5.92395 25.1323 5.50192 24.7383L3.3417 22.7203C2.719 22.1393 2.2854 21.3733 2.10044 20.5273C1.91547 19.6813 1.9882 18.7969 2.30863 17.9954C2.62907 17.1938 3.18151 16.5145 3.89013 16.0506C4.59876 15.5867 5.42884 15.361 6.26645 15.4044L9.17341 15.5584C9.74169 15.5894 10.3099 15.4967 10.8413 15.2861C11.3727 15.0755 11.8554 14.7518 12.2581 14.336C12.6608 13.9202 12.9746 13.4215 13.179 12.8722C13.3835 12.323 13.4741 11.7355 13.445 11.1477L13.2894 8.14139C13.2439 7.27375 13.4596 6.41288 13.9069 5.67732C14.3542 4.94177 15.0109 4.36771 15.7868 4.03421C16.5626 3.70072 17.4193 3.62419 18.239 3.81516C19.0586 4.00613 19.8008 4.45522 20.3634 5.10057L22.3148 7.33464C22.6953 7.77174 23.1604 8.12123 23.68 8.36046C24.1995 8.59969 24.7619 8.72332 25.3306 8.72332C25.8993 8.72332 26.4617 8.59969 26.9813 8.36046C27.5008 8.12123 27.9659 7.77174 28.3465 7.33464L30.2978 5.10057C30.8612 4.45814 31.603 4.01167 32.4215 3.82239C33.24 3.6331 34.095 3.71026 34.8694 4.04329"
                  stroke="#09951F"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M17.2227 23.5822L22.8077 31.2843C23.1087 31.6991 23.4964 32.0384 23.9418 32.2768C24.3873 32.5152 24.879 32.6466 25.3803 32.6612C25.8817 32.6758 26.3798 32.5732 26.8375 32.361C27.2951 32.1489 27.7006 31.8327 28.0238 31.436L51.9995 2"
                  stroke="#09951F"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <h4 class="success-modal-green-text">Eligibility Confirmed</h4>
              
            </div>
          </div>

          <h5
            class="text-center col-md-12 pointer text-end"
            @click="(successDialog = false), (showOverlay = false)"
          >
            Close
          </h5>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      hide-overlay
      v-model.trim="errorDialog"
      height="293"
      width="400"
      content-class="modal-member-check"
    >
      <v-card>
        <v-card-text>
          <div class="col-md-12">
            <div class="row text-center justify-center">
              <h3 class="text-center mt-5 mb-5 text-underline black--text">
                Member Eligibility Check
              </h3>
            </div>
          </div>

          <div class="col-md-12 text-center mt-3">
            <div class="red-error-modal">
              <svg
                class="mt-1"
                width="44"
                height="44"
                viewBox="0 0 54 54"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M23.7713 5.74543C24.1794 6.19751 24.6778 6.55892 25.2344 6.80627C25.7909 7.05363 26.3931 7.18144 27.0021 7.18144C27.6111 7.18144 28.2133 7.05363 28.7698 6.80627C29.3263 6.55892 29.8248 6.19751 30.2329 5.74543L32.3216 3.42968C32.9244 2.76457 33.718 2.30209 34.5938 2.10559C35.4696 1.90908 36.3847 1.98815 37.2138 2.33198C38.0429 2.6758 38.7455 3.26755 39.2253 4.02621C39.7052 4.78487 39.9388 5.67334 39.8942 6.56994L39.7342 9.68131C39.7033 10.2898 39.8003 10.898 40.0191 11.4667C40.2378 12.0353 40.5734 12.5518 41.0042 12.9826C41.435 13.4134 41.9513 13.7491 42.5198 13.9679C43.0884 14.1867 43.6965 14.2837 44.3049 14.2528L47.4157 14.0928C48.3145 14.0449 49.2061 14.2769 49.9676 14.7569C50.7291 15.2368 51.3231 15.941 51.6679 16.7725C52.0127 17.6041 52.0913 18.5221 51.8929 19.4002C51.6945 20.2783 51.2287 21.0732 50.5599 21.6756L48.2445 23.7647C47.7925 24.1729 47.4312 24.6714 47.1839 25.228C46.9366 25.7847 46.8088 26.387 46.8088 26.9961C46.8088 27.6052 46.9366 28.2075 47.1839 28.7641C47.4312 29.3208 47.7925 29.8193 48.2445 30.2275L50.5599 32.3165C51.2275 32.9189 51.6922 33.7132 51.8902 34.5904C52.0882 35.4676 52.0098 36.3846 51.6657 37.2155C51.3216 38.0463 50.7287 38.7501 49.9685 39.2303C49.2083 39.7105 48.3181 39.9435 47.4202 39.8972L44.3094 39.7372C43.701 39.7066 43.0931 39.8039 42.5247 40.0228C41.9563 40.2417 41.4401 40.5774 41.0094 41.0081C40.5787 41.4389 40.2431 41.9552 40.0243 42.5237C39.8054 43.0922 39.7081 43.7002 39.7387 44.3087L39.8987 47.42C39.9449 48.3181 39.712 49.2085 39.2319 49.9688C38.7518 50.7292 38.0481 51.3222 37.2174 51.6663C36.3867 52.0105 35.4699 52.0889 34.5929 51.8909C33.7158 51.6928 32.9216 51.228 32.3194 50.5603L30.2307 48.2445C29.8225 47.7925 29.3241 47.431 28.7676 47.1837C28.2111 46.9363 27.6089 46.8085 26.9999 46.8085C26.3909 46.8085 25.7886 46.9363 25.2321 47.1837C24.6756 47.431 24.1772 47.7925 23.7691 48.2445L21.6737 50.5625C21.0714 51.2302 20.2772 51.6951 19.4002 51.8931C18.5232 52.0912 17.6063 52.0127 16.7757 51.6685C15.945 51.3244 15.2413 50.7314 14.7612 49.971C14.2811 49.2107 14.0481 48.3203 14.0944 47.4222L14.2544 44.3109C14.2853 43.7024 14.1883 43.0941 13.9695 42.5255C13.7508 41.9568 13.4152 41.4404 12.9844 41.0096C12.5537 40.5787 12.0373 40.2431 11.4688 40.0243C10.9002 39.8055 10.2921 39.7084 9.68371 39.7394L6.57289 39.8994C5.67751 39.9419 4.79083 39.707 4.03398 39.2266C3.27713 38.7462 2.687 38.0439 2.34423 37.2155C2.00145 36.3871 1.92273 35.473 2.11883 34.5982C2.31492 33.7233 2.77627 32.9304 3.43985 32.3277L5.75519 30.2386C6.20719 29.8304 6.56853 29.3319 6.81585 28.7753C7.06316 28.2186 7.19095 27.6163 7.19095 27.0072C7.19095 26.3981 7.06316 25.7958 6.81585 25.2392C6.56853 24.6825 6.20719 24.184 5.75519 23.7758L3.43985 21.6868C2.77136 21.0846 2.30584 20.2901 2.10731 19.4124C1.90878 18.5348 1.98701 17.6172 2.33123 16.7859C2.67544 15.9546 3.26874 15.2503 4.0295 14.7701C4.79027 14.2898 5.68113 14.0571 6.57955 14.1039L9.69037 14.2639C10.2999 14.296 10.9094 14.1994 11.4792 13.9805C12.0489 13.7616 12.5663 13.4252 12.9976 12.9932C13.4289 12.5612 13.7644 12.0432 13.9825 11.473C14.2006 10.9028 14.2962 10.2931 14.2633 9.68353L14.1033 6.57216C14.0603 5.67644 14.2948 4.78927 14.7749 4.03191C15.255 3.27455 15.9573 2.68395 16.7856 2.34082C17.614 1.99769 18.5281 1.91878 19.403 2.11487C20.2779 2.31095 21.0709 2.77247 21.6737 3.43634L23.7713 5.74543Z"
                  stroke="#E40000"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M34 21L19 36"
                  stroke="#E40000"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M19 21L34 36"
                  stroke="#E40000"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <div class="error-modal-red-text" v-if="errorMessage.length > 0">
                {{ errorMessage }}
              </div>
              <div class="error-modal-red-text">
                Not Eligible - Verify Information
              </div>
              <div class="error-modal-red-text">
                and ReRun Eligibility Check
              </div>
            </div>
          </div>

          <h5
            class="text-center col-md-12 pointer text-end"
            @click="(errorDialog = false), (showOverlay = false)"
          >
            Close
          </h5>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-row justify="center">
      <v-dialog v-model.trim="dialog1" scrollable max-width="600px">
        <v-card>
          <v-card-text>
            <v-card class="text-center justify-center">
              <div class="mt-10">
                <img src="/mypha.png" alt="" />
              </div>
              <v-card-title class="text-center justify-center blue-text"
                >Click to Connect with Your Personal Health assistant
              </v-card-title>
            </v-card>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn class="text-gray" text @click="dialog1 = false">
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <errorModal ref="error_modal" v-on:confirm="closeErrorModal"></errorModal>
  </div>
</template>
<script>
import api from "../../../services/api";
import errorModal from "../../TablesTemplate/ErrorDialog.vue";
export default {
  components: { errorModal },
  data() {
    return {
      visitPasses: [
        {
          groupId: "1A853B",
          payerId: "295681",
          member: "Bill Smith",
          memberId: "142-458-251-746",
          provider: "Advanced Imaging",
          priorAuth: "Pending",
          serviceType: "Imaging",
          service: "MRI L-Spine",
          membersCapay: "0$",
          memberDeductible: "0$",
        },
        {
          groupId: "2B4563B",
          payerId: "952054",
          member: "Brian James",
          memberId: "861-974-681-742",
          provider: "Rodwan Hiba MD",
          priorAuth: "154-856-472-01",
          serviceType: "Procedure",
          service: "Colonoscopy",
          membersCapay: "0$",
          memberDeductible: "0$",
        },
        {
          groupId: "7C54793",
          payerId: "24756698",
          member: "James Smithson",
          memberId: "684-279-018-067",
          provider: "James Smithson MD",
          priorAuth: "745-412-394-284",
          serviceType: "Office Visit",
          service: "Office Visit - New Patient",
          membersCapay: "0$",
          memberDeductible: "0$",
        },
      ],
      items: [
        {
          img: "/cards/Group (2).png",
          title: "Virtual Visit",
        },
        {
          img: "/cards/Group (3).png",
          title: "Talk to a Navigator",
        },
        {
          img: "/cards/Group (4).png",
          title: "Setup a Procedure",
        },
        {
          img: "/cards/Group (5).png",
          title: "Find a Doctor",
        },
        {
          img: "/cards/Group (6).png",
          title: "Find Other Services",
        },
        {
          img: "/cards/hospital.png",
          title: "Find a Facility",
        },
        {
          img: "/cards/Group (8).png",
          title: "Apaly Card",
        },
        {
          img: "/cards/Group (9).png",
          title: "Visit Passes",
        },
        {
          img: "/cards/Group (9).png",
          title: "Prior Auths",
        },
      ],
      precentageCards: [
        {
          title: "Clients and Members",
          percentage: "74",
          percentage1: "1,450",
          clients: true,
        },
        {
          title: "Projected Savings",
          percentage: "28%",
          desc: "accross all clients, compared to current average network lease costs",
        },
        {
          title: "Provider Coverage",
          percentage: "94%",
          desc: "percentage of members with providers within a 10 mile radius of their zip code",
        },
        {
          title: "Providers",
          percentage: "48,000",
          desc: "based on current provider list filters",
        },
        {
          title: "Current Contract Rates",
          percentage: "150%",
          percentage1: "180%",
          desc1:
            "of Medicare benchmark rates, as an averages accross all clients",
          inpatient: true,
        },
        {
          title: "Contract Renewals",
          percentage: "5",
          desc: "number of client contracts up for renewal within the next 90 days",
        },
      ],
      dialogm1: "",
      dialog: false,
      dialog1: false,
      activeTab: "",
      usersPhone: "",
      noPhoneMessage: "",
      member: "",
      phoneDialog: false,
      payerID: "",
      groupID: "",
      planID: "",
      memberID: "",
      firstName: "",
      lastName: "",
      dob: "",
      errorMessage: "",
      dialog: false,
      showOverlay: false,
      errorDialog: false,
      menu: false,
      successDialog: false,
    };
  },
  computed: {
    changePage() {
      let modal = false;
      //  if(this.$store.getters.getIconFromFooter == 'passess'){
      //         modal = true
      //         this.dialog = true
      //  }else{
      //      this.dialog = false
      //  }

      return modal;
    },
  },
  created() {
    this.getMemberDetails();
    this.getUsersPhone();
    //   this.changePage;
  },
  methods: {
    showModal(type) {
      if (type == 1) {
        this.successDialog = true;
      } else {
        this.errorDialog = true;
      }
    },
    checkEligibility() {
      let data = {
        firstName: this.firstName,
        lastName: this.lastName,
        dob: this.dob,
        payerId: this.payerID,
        groupId: this.groupID,
        planId: this.planID,
        memberId: this.memberID,
      };
      this.errorMessage = "";
      api()
        .post("/members/eligibility/check", data)
        .catch((err) => {
          if (err) {
            if (err.status == 500) {
              this.errorMessage =
                "There was some error. Please contact system administrator or try again later!";
            } else {
              this.errorMessage = err.response.data;
            }

            this.showModal(0);
            this.showOverlay = true;
          }
          return;
        })
        .then((res) => {
          if (res && res.data) {
            this.$store.commit("setSingleMember", res.data);
            this.member = res.data;
            this.showModal(1);

            this.showOverlay = true;
          } else {
            this.showModal(0);
            this.showOverlay = true;
          }
        });
    },
    closeErrorModal() {
      this.$refs.error_modal.closePopUp();
    },
    getMemberDetails() {
      let user = JSON.parse(localStorage.getItem("user"));
      let member = user.member;

      api()
        .get(`/members/${member}`)
        .then((res) => {
          this.member = res.data.member;
        });
    },
    getUsersPhone() {
      let user = JSON.parse(localStorage.getItem("user"));
      let member = user.member;
      //     61cae0336e5c9c546bcecdf4
      api()
        .get(`/members/${member}/navigatorPhone`)
        .then((res) => {
          this.usersPhone = res.data.phone;
        });
    },
    changeActiveTab(tab) {
      tab === this.activeTab ? (this.activeTab = null) : (this.activeTab = tab);
    },
    checkIfTabIsActive(tab) {
      return tab === this.activeTab
        ? "cursor:pointer;background:grey;color:white !important"
        : "cursor:pointer;background:white";
    },
    talkToNavigator() {
      this.dialog1 = !this.dialog1;
    },

    virtualVisit() {
      this.dialog = !this.dialog;
      this.activeTab = "pending";
      this.$router.push("/member/visit-passes");
    },
    textUser() {
      window.location.href = "sms:/*+38977882284*/?body=/*Hello from Appaly!*/";
    },
    callUser() {
      if (this.usersPhone != "Phone number not available!") {
        window.open('tel:'+this.usersPhone,  '_self');
      } else {
        this.noPhoneMessage = this.usersPhone;
        this.$refs.error_modal.openPopUp(this.usersPhone);
      }
    },
    clientsTable(item) {},
  },
};
</script>

